#
msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2025-09-16 18:40+0300\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: es\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: @lingui/cli\n"

#. placeholder {0}: item.maxSurge
#. placeholder {0}: item.maximum
#. placeholder {0}: item.minimum
#. placeholder {1}: item.maxSurge
#. placeholder {1}: item.maximum
#. placeholder {1}: item.minimum
#: src/modules/services/FailoverNodeSelect.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "{0} {1, plural, one {node} other {nodes}}"
msgstr ""

#. placeholder {0}: uploadStats.uploadedFiles
#. placeholder {1}: uploadStats.totalFiles
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{0} of {1} files uploaded"
msgstr "{0} de {1} archivos subidos"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "{name} will be deleted permanently."
msgstr "{name} se eliminará de forma permanente."

#: src/modules/storage/StorageList.tsx
msgid "{number_of_buckets, plural, one {bucket} other {buckets}}"
msgstr ""

#. {resourceTypeName} is eg. 'virtual machine' or 'billing account'
#: src/modules/api/resourceTypeException.tsx
msgid "{resourceTypeName} with ID {id} not found"
msgstr ""

#. ONLY:bn
#: src/styles/tenbyte/theme.tsx
msgid "<0><1>Individual/Proprietor: NID, Passport, or Driver's License.</1><2>Company/Corporate: Trade License.</2><3>Financial & Legal: Tax Identification Number (TIN), VAT Certificate.</3></0>"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "1 bare metal server"
msgstr "1 servidor físico"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 day"
msgstr "1 día"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "1 hour"
msgstr "1 hora"

#: src/modules/billing/omise/OmisePaymentForm.tsx
msgid "10 digit TrueMoney mobile number starting with 0"
msgstr "Número móvil de TrueMoney de 10 dígitos que comienza con 0"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "3 days"
msgstr "3 días"

#: src/modules/compute/VmView.tsx
msgid "4 weeks"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "6 hours"
msgstr "6 horas"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "7 days"
msgstr "7 días"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "A discount has been applied for all services under this billing account."
msgstr "Se ha aplicado un descuento a todos los servicios bajo esta cuenta de facturación."

#: src/modules/compute/VmCreate.tsx
msgid "A user account will be created with this username. It can be used to log in to the VM. Can contain ASCII letters, digits, underscores and hyphens. Must start with a letter or underscore. Maximum length is 25 characters."
msgstr "Se creará una cuenta de usuario con este nombre. Se podrá usar para iniciar sesión en la máquina virtual. Puede contener letras ASCII, dígitos, guiones bajos y guiones. Debe comenzar con una letra o un guion bajo. La longitud máxima es de 25 caracteres."

#: src/modules/network/NetworkCreate.tsx
msgid "A virtual private cloud (VPC) is a private network interface for collections of your resources. VPC network is available at no additional cost."
msgstr "Una nube virtual privada (VPC) es una red privada para conjuntos de sus recursos. La red VPC está disponible sin costo adicional."

#: src/modules/access/AcceptInvitationModal.tsx
#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept"
msgstr "Aceptar"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accept invitation"
msgstr "Aceptar invitación"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/user/ProfileView.tsx
msgid "Accepted"
msgstr "Aceptado"

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Accepting this access invitation will grant you permission to act as \"{name}\" and perform all operations on behalf of the user."
msgstr "Al aceptar esta invitación de acceso, obtendrá permiso para actuar como \"{name}\" y realizar todas las operaciones en nombre del usuario."

#. Label for dropdown menu that has options related to file sharing and permissions. | POS: Noun
#. Title for section that contains credentials to connect to a database
#: src/modules/access/AccessList.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/Access.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Access"
msgstr "Acceso"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Access credentials"
msgstr "Credenciales de acceso"

#: src/modules/api/resourceTypes.tsx
msgid "Access delegation"
msgstr "Delegación de acceso"

#: src/modules/user/ProfileView.tsx
msgid "Access group"
msgstr "Grupo de acceso"

#: src/modules/user/InvitationNotice.tsx
msgid "Access has been shared with you"
msgstr "Se ha compartido acceso con usted"

#: src/modules/api/resourceTypes.tsx
msgid "Access invitation"
msgstr "Invitación de acceso"

#. placeholder {0}: item.access_owner
#: src/modules/user/InvitationNotice.tsx
msgid "Access invitation from {0} is pending"
msgstr "La invitación de acceso de {0} está pendiente"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Access key ID"
msgstr "ID de clave de acceso"

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access name"
msgstr "Nombre del acceso"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Access scope"
msgstr "Ámbito de acceso"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
msgid "Access type"
msgstr "Tipo de acceso"

#. Dialog title
#: src/modules/user/ActAsModal.tsx
msgid "Access user"
msgstr "Acceder como usuario"

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
#: src/modules/billing/NoValidBillingAccountNotice.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account details are being validated."
msgstr "Se están validando los datos de la cuenta."

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "Account details must be validated"
msgstr "Los datos de la cuenta deben validarse"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Account ID"
msgstr "ID de la cuenta"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Account name"
msgstr "Nombre de la cuenta"

#. Menu item to impersonate another user
#: src/modules/user/ActAsModal.tsx
#: src/modules/user/UserMenu.tsx
msgid "Act as"
msgstr "Actuar como"

#. placeholder {0}: impersonation.access_owner
#: src/modules/user/ImpersonateTopItem.tsx
msgid "Acting as <0>{0}</0>"
msgstr "Actuando como <0>{0}</0>"

#. Login page title when email verification is required
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Action required"
msgstr ""

#. Billing account status
#. Disk status
#. Service status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Active"
msgstr "Activo"

#: src/modules/storage/StorageCreate.tsx
msgid "Actual cost of your storage is calculated hourly based on your actual usage, no upfront payments. For every started GB the price is rounded up to next whole GB."
msgstr "El costo real de su almacenamiento se calcula por hora según su uso real, sin pagos por adelantado. Por cada GB iniciado, el precio se redondea al siguiente GB entero."

#: src/modules/services/ServiceView.tsx
msgid "Actual price is determined by compute and storage usage. Persistent volumes of hibernated clusters will still be charged for. See billing account current usage for more detailed information."
msgstr "El precio real se determina por el uso de cómputo y almacenamiento. Los volúmenes persistentes de los clústeres hibernados seguirán generando cargos. Consulta el uso actual de la cuenta de facturación para obtener información más detallada."

#. Add a new row; Button action
#: src/components/EditableList.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add"
msgstr "Añadir"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Add a a payment method that supports automated top up."
msgstr ""

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Add additional disk"
msgstr "Agregar disco adicional"

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one forwarding rule"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Add at least one target server"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Add custom configuration for the virtual machine"
msgstr "Agregar configuración personalizada para la máquina virtual"

#: src/modules/user/ProfileView.tsx
msgid "Add first name"
msgstr "Agregar nombre"

#: src/modules/services/IpWhitelist.tsx
msgid "Add IP"
msgstr "Añadir IP"

#: src/modules/user/ProfileView.tsx
msgid "Add last name"
msgstr "Agregar apellido"

#: src/components/table/DetailsTableName.tsx
msgid "Add name"
msgstr "Añadir nombre"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add new payment method..."
msgstr "Agregar nuevo método de pago..."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Add new reservation"
msgstr ""

#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add new rule"
msgstr "Añadir nueva regla"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Add node"
msgstr "Agregar nodo"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Add node pool"
msgstr "Agregar grupo de nodos"

#: src/modules/billing/ActionButtons.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Add payment method"
msgstr "Añadir método de pago"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Add payment method later"
msgstr "Agregar método de pago más tarde"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "Add rule"
msgstr "Añadir regla"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Add SSH key"
msgstr "Agregar clave SSH"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Add sub-interface"
msgstr "Agregar subinterfaz"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Add target server"
msgstr "Añadir servidor de destino"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "Add user"
msgstr "Agregar usuario"

#: src/modules/access/delegation/DelegationView.tsx
msgid "Add users"
msgstr "Agregar usuarios"

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Adding payment method failed"
msgstr "No se pudo agregar el método de pago"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/network/NetworkList.tsx
msgid "Address"
msgstr "Dirección"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Address line 2"
msgstr "Dirección (línea 2)"

#. Link to administrative user interface
#: src/modules/user/UserMenu.tsx
msgid "Admin view"
msgstr "Vista de administración"

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Administrator action"
msgstr ""

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/WTabs.tsx
msgid "All"
msgstr "Todos"

#. A firewall rule that applies to every source or destination IP address
#: src/modules/network/firewall/firewallLabels.tsx
msgid "All IP addresses"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
msgid "All permissions"
msgstr ""

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All TCP"
msgstr "Todo TCP"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "All UDP"
msgstr "Todo UDP"

#: src/modules/api/resourceTypes.tsx
msgid "Allocate a floating IP and start managing your network."
msgstr "Asigne una dirección IP flotante y empiece a gestionar su red."

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Allocated"
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "Allocating a new IPv4 address allows you to assign it to one of your existing resources or reserve it for later use."
msgstr "La asignación de una nueva dirección IPv4 le permite asignarla a uno de sus recursos existentes o reservarla para usarla más adelante."

#: src/modules/login/Login.tsx
msgid "Already have an account?"
msgstr "¿Ya tiene una cuenta?"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Amount"
msgstr "Importe"

#. Field label for reservation upfront cost
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Amount billed upfront"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Amount is too low"
msgstr "El monto es demasiado bajo"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Amount should be positive"
msgstr "El importe debe ser positivo"

#: src/modules/billing/AutomatedTopUpModal.tsx
msgid "Amount should not be less than than minimum top up"
msgstr "El importe no debe ser inferior a la recarga mínima"

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "An active billing account is needed to create resources."
msgstr "Se necesita una cuenta de facturación activa para crear recursos."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "An active billing account is needed to use this feature."
msgstr "Se necesita una cuenta de facturación activa para usar esta función."

#: src/modules/billing/account_validation/BillingAccountValidationBlock.tsx
msgid "An e-mail with instructions has been sent to you."
msgstr "Se le ha enviado un correo electrónico con instrucciones."

#: src/components/modal/WModal.tsx
#: src/components/sidebar/ListErrorBoundary.tsx
msgid "An error happened"
msgstr "Ocurrió un error"

#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/firewall/ruleSpec.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Any"
msgstr "Cualquiera"

#: src/modules/access/AccessList.tsx
#: src/modules/dashboard/WelcomeBlock.tsx
#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "API"
msgstr "API"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "API documentation"
msgstr "Documentación de la API"

#: src/modules/api/resourceTypes.tsx
msgid "API token"
msgstr "Token de API"

#: src/modules/compute/labels.tsx
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "App catalog"
msgstr "Catálogo de aplicaciones"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Appearance"
msgstr "Apariencia"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Apply for payment by invoice"
msgstr "Solicitar pago por factura"

#: src/modules/compute/SubInterfaceDeleteModal.tsx
msgid "Are you sure you want to delete sub-interface with uuid {ifUuid}?"
msgstr "¿Está seguro de que desea eliminar la subinterfaz con UUID {ifUuid}?"

#: src/modules/compute/SshKeyDeleteModal.tsx
msgid "Are you sure you want to delete the public key \"{name}\"?"
msgstr "¿Está seguro de que desea eliminar la clave pública \"{name}\"?"

#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Are you sure you want to log out?"
msgstr "¿Está seguro de que desea cerrar sesión?"

#: src/modules/network/NetworkCreate.tsx
msgid "Assign to"
msgstr "Asignar a"

#. State of IP address, attached to a resource such as a virtual machine
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
msgid "Assigned"
msgstr "Asignada"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Assigned to"
msgstr "Asignada a"

#: src/modules/access/AccessCreate.tsx
msgid "At least one email is required"
msgstr "Se requiere al menos un correo electrónico"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "At least one IP is required"
msgstr "Se requiere al menos una IP"

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "At least one node pool must have autoscaler minimum value as 1 or more."
msgstr "Al menos un grupo de nodos debe tener el valor mínimo del autoescalado en 1 o más."

#: src/modules/compute/VmView.tsx
msgid "Attach firewall"
msgstr "Asociar firewall"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Attach resource"
msgstr "Vincular recurso"

#: src/modules/disks/DiskList.tsx
msgid "Attached"
msgstr "Adjunto"

#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
msgid "Attached to"
msgstr "Adjunto a"

#. Explanation: Switching the color schema automatically. |Alternatives: 'Automatic'
#: src/modules/main/ColorSchemeMenu.tsx
msgid "Auto"
msgstr "Automático"

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Auto update"
msgstr "Actualización automática"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Automated payment"
msgstr "Pago automático"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automated top up"
msgstr "Recarga automática"

#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your service. Backups will be stored for 7 days, meaning you will have 7 latest backups."
msgstr "Las copias de seguridad a nivel de sistema están habilitadas. Use las imágenes de copia de seguridad para restaurar su servicio. Las copias de seguridad se almacenarán durante 7 días, lo que significa que tendrá las 7 copias de seguridad más recientes."

#: src/modules/compute/VmView.tsx
msgid "Automatic system-level backups are enabled. Use the backup images to restore your virtual machine or create a new virtual machine from the backup with modified size parameters."
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Automatic updates will not update preview versions."
msgstr "Las actualizaciones automáticas no actualizarán las versiones preliminares."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Automatically top up (min. <0/>)"
msgstr "Recargar automáticamente (mín. <0/>)"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler max."
msgstr "Máx. de autoescalado"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Autoscaler min."
msgstr "Mín. de autoescalado"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Available"
msgstr "Disponible"

#: src/modules/services/ServiceView.tsx
msgid "Awake"
msgstr "Activo"

#. Button action
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Back"
msgstr "Atrás"

#: src/modules/user/ImpersonateTopItem.tsx
#: src/modules/user/UserMenu.tsx
msgid "Back to your account"
msgstr "Volver a su cuenta"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
msgid "Backups"
msgstr "Copias de seguridad"

#. Table column: billing account balance when the change happened
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became negative"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Balance became positive"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Balance history"
msgstr "Historial de saldo"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for {days, plural, one {# day} other {# days}} (limit: {threshold, plural, one {# day} other {# days}})"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Balance negative for too long"
msgstr ""

#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/metal/MetalList.tsx
msgid "Bare metal"
msgstr "Servidores físicos"

#: src/modules/api/resourceTypes.tsx
msgid "Bare metal server"
msgstr "Servidor físico"

#: src/modules/billing/BaseCurrencyField.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Base currency"
msgstr "Moneda base"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Begin your billing account validation process."
msgstr "Inicie su proceso de validación de la cuenta de facturación."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Below is an example of how to configure this sub-interface on a Linux server."
msgstr "A continuación se muestra un ejemplo de cómo configurar esta subinterfaz en un servidor Linux."

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Below the top-up threshold"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Billed"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Billing"
msgstr "Facturación"

#: src/components/table/DetailsTableBillingAccount.tsx
#: src/components/table/DetailsTableBillingAccount.tsx
#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/forms/BillingAccountField.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Billing account"
msgstr "Cuenta de facturación"

#. Price list annotation
#: src/modules/pricing/PricingModal.tsx
msgid "Billing account \"{title}\" has discount {discount_percentage}%"
msgstr "La cuenta de facturación \"{title}\" tiene un descuento del {discount_percentage}%"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account created"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account deleted"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Billing account is limited"
msgstr "La cuenta de facturación está limitada"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Billing account name"
msgstr "Nombre de la cuenta de facturación"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Billing account override"
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account reactivated"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account suspended"
msgstr "Cuenta de facturación suspendida"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account updated"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Billing account validation"
msgstr ""

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Billing account validation was rejected"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Billing account waiting for validation"
msgstr ""

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Billing accounts"
msgstr "Cuentas de facturación"

#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "Billing cycle"
msgstr ""

#: src/modules/disks/disk/DiskView.tsx
msgid "Boot"
msgstr "Arranque"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Boot from ISO medium"
msgstr "Arrancar desde un medio ISO"

#. Virtual machine choice: UEFI or BIOS
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Boot mode"
msgstr ""

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Booting is only possible when the virtual machine is stopped."
msgstr "Solo es posible arrancar cuando la máquina virtual está detenida."

#. {payment method} provided by {payment gateway name}
#: src/modules/billing/utils.tsx
msgid "by {gatewayName}"
msgstr "por {gatewayName}"

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "By continuing with the top up you agree to the <0>Terms & Conditions</0>, <1>Privacy Policy</1> & <2>Refund Policy</2>."
msgstr "Al continuar con la recarga, usted acepta los <0>Términos y condiciones</0>, la <1>Política de privacidad</1> y la <2>Política de reembolsos</2>."

#: src/modules/compute/VmView.tsx
msgid "By disabling backups there will not be any further automatic backups made from your virtual machine. Backups done by this point will be kept as is and you can still use them. You can enable backups again whenever needed."
msgstr "Al desactivar las copias de seguridad, no se realizarán más copias automáticas de su máquina virtual. Las copias realizadas hasta este momento se conservarán tal cual y podrá seguir utilizándolas. Podrá volver a activar las copias de seguridad cuando lo necesite."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Global”, all resources under this user account can be accessed. Exercise caution when selecting “Global” scope."
msgstr "Al seleccionar “Global”, se podrá acceder a todos los recursos de esta cuenta de usuario. Tenga precaución al seleccionar el ámbito “Global”."

#: src/modules/access/AccessCreate.tsx
msgid "By selecting “Restricted”, access will be limited to resources belonging to the selected billing account."
msgstr "Al seleccionar “Restringido”, el acceso se limitará a los recursos que pertenecen a la cuenta de facturación seleccionada."

#: src/modules/login/auth0/Auth0Login.tsx
msgid "By signing up, you agree to the <0>Terms of Service</0>"
msgstr "Al registrarse, usted acepta los <0>Términos del servicio</0>"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Campaign code"
msgstr "Código de campaña"

#: src/modules/dashboard/UserAccess.tsx
msgid "Can access me"
msgstr "Pueden acceder a mí"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Cancel"
msgstr "Cancelar"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Cancel uploads"
msgstr "Cancelar subidas"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Cancelled"
msgstr ""

#: src/modules/billing/payment_forms/labels.tsx
msgid "Card number"
msgstr "Número de tarjeta"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Card verification failed"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change"
msgstr "Cambiar"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
msgid "Change password"
msgstr "Cambiar contraseña"

#: src/modules/login/Login.tsx
msgid "Change your password by clicking the verification link we just sent to your inbox."
msgstr "Cambie su contraseña haciendo clic en el enlace de verificación que acabamos de enviar a su bandeja de entrada."

#. Table column: who changed the billing account status
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Changed by"
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Changing the password failed"
msgstr "No se pudo cambiar la contraseña"

#: src/modules/compute/ChangePasswordModal.tsx
msgid "Changing the password is only possible when the virtual machine is running."
msgstr "Solo es posible cambiar la contraseña cuando la máquina virtual está en ejecución."

#: src/modules/billing/forms/BillingAccountField.tsx
msgid "Choose a billing account for your new resource to consolidate your resources under a suitable payment method."
msgstr "Elija una cuenta de facturación para su nuevo recurso y así consolidar sus recursos bajo un método de pago adecuado."

#: src/modules/access/AccessCreate.tsx
msgid "Choose a billing account you wish to share access to"
msgstr "Elija la cuenta de facturación a la que desea conceder acceso"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose a resource to assign the IP to or leave it unassigned. You can always assign the IP to a suitable resource later"
msgstr "Elija un recurso al que asignar la IP o déjela sin asignar. Siempre podrá asignar la IP a un recurso adecuado más adelante"

#: src/modules/disks/DiskCreate.tsx
msgid "Choose a virtual machine to attach the disk to, or leave it detached and connect it to a virtual machine later."
msgstr ""

#: src/modules/compute/VmCreate.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "Choose a VPC network for your resource from already existing one or create a new private network."
msgstr "Elija una red VPC para su recurso de entre las existentes o cree una nueva red privada."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Choose billing account"
msgstr "Elegir cuenta de facturación"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Choose method"
msgstr "Elegir método"

#: src/modules/network/NetworkCreate.tsx
msgid "Choose the VPC network the target servers are in."
msgstr "Elija la red VPC en la que se encuentran los servidores de destino."

#: src/modules/compute/VmCreate.tsx
msgid "Choose UEFI if the VM you are importing requires it."
msgstr ""

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "City"
msgstr "Ciudad"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Cleaning"
msgstr "Limpieza"

#. Billing account restriction level | POS: Adjective
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Clear"
msgstr ""

#: src/modules/notifications/NotificationMenu.tsx
msgid "Clear all"
msgstr "Borrar todo"

#. Button: Remove the over-ride of the billing account for this bucket
#: src/modules/storage/bucket/BucketView.tsx
msgid "Clear override"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Clear uploads"
msgstr "Borrar subidas"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Click the button to connect to PayPal."
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone"
msgstr "Clonar"

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
msgid "Clone resource"
msgstr "Clonar recurso"

#. Button action
#: src/components/modal/WModal.tsx
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/access/delegation/AddImpersonationForm.tsx
#: src/modules/compute/AddFirewallForm.tsx
#: src/modules/network/firewall/AddResourceForm.tsx
#: src/modules/network/loadbalancer/AddForwardingRuleForm.tsx
#: src/modules/network/loadbalancer/AddTargetServerForm.tsx
#: src/modules/services/AddIpForm.tsx
msgid "Close"
msgstr "Cerrar"

#. Label for an authentication error code
#: src/modules/login/auth0/Auth0Login.tsx
msgid "Code:"
msgstr ""

#. Server has been pre-paid
#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Committed"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Company name"
msgstr "Nombre de la empresa"

#: src/styles/dataxion/theme.tsx
msgid "Company RNE number"
msgstr "Número RNE de la empresa"

#: src/modules/access/token/TokenView.tsx
msgid "Comprehensive API manual with code samples is available here:"
msgstr "El manual completo de la API con ejemplos de código está disponible aquí:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Compute"
msgstr "Cómputo"

#. Alternative: Configure a custom subnet range
#: src/modules/network/NetworkCreate.tsx
msgid "Configure my own"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Confirm email"
msgstr "Confirmar correo electrónico"

#: src/modules/compute/PasswordFields.tsx
msgid "Confirm password"
msgstr "Confirmar contraseña"

#: src/modules/login/Login.tsx
msgid "Confirm your email address by clicking the verification link we just sent to your inbox."
msgstr "Confirme su dirección de correo electrónico haciendo clic en el enlace de verificación que acabamos de enviar a su bandeja de entrada."

#: src/components/modal/DeleteModal.tsx
#: src/modules/main/LogoutConfirmDialog.tsx
msgid "Confirmation"
msgstr "Confirmación"

#: src/modules/compute/WVnc.tsx
msgid "Connect"
msgstr "Conectar"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Connect to PayPal first"
msgstr ""

#: src/modules/compute/WVnc.tsx
msgid "Connecting"
msgstr "Conectando"

#: src/modules/billing/progressLabels.tsx
msgid "Connecting payment method"
msgstr "Conectando el método de pago"

#. Title for section that contains credentials to connect to a database
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/ServiceView.tsx
msgid "Connection details"
msgstr "Detalles de conexión"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's name"
msgstr "Nombre de la persona de contacto"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Contact person's phone"
msgstr "Teléfono de la persona de contacto"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/support/ContactSupportButton.tsx
msgid "Contact support"
msgstr "Contactar con soporte"

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
#: src/modules/login/ConsentForm.tsx
#: src/modules/login/Login.tsx
msgid "Continue"
msgstr "Continuar"

#: src/components/ClipBoardTooltip.tsx
msgid "Copied!"
msgstr "¡Copiado!"

#. Full form: Copy to clipboard
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Copy"
msgstr "Copiar"

#: src/modules/services/Access.tsx
msgid "Copy config to clipboard"
msgstr "Copiar la configuración al portapapeles"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Copy public URL"
msgstr "Copiar URL pública"

#: src/components/ClipBoardTooltip.tsx
msgid "Copy to clipboard"
msgstr "Copiar al portapapeles"

#. All the main resources and services offered by the cloud platform
#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Core services"
msgstr "Servicios principales"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Country"
msgstr "País"

#. Part of address
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "County"
msgstr ""

#: src/modules/compute/MetricsGrid.tsx
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/compute/VmSizeSelect.tsx
msgid "CPU"
msgstr "CPU"

#. Button: Create a new resource
#: src/components/forms/CreateFormAction.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Create"
msgstr "Crear"

#. Button: Create new billing account
#: src/modules/dashboard/BillingAccounts.tsx
msgctxt "Should be short (1-3 words)"
msgid "Create"
msgstr "Crear"

#: src/modules/billing/BillingList.tsx
msgid "Create a billing account first, then you can start creating resources."
msgstr "Cree primero una cuenta de facturación y, a continuación, podrá empezar a crear recursos."

#: src/modules/api/resourceTypes.tsx
msgid "Create a dedicated bare metal server and run your application with maximum performance."
msgstr "Cree un servidor físico dedicado y ejecute su aplicación con el máximo rendimiento."

#: src/modules/error/ErrorFallback.tsx
msgid "Create a new {resourceTypeName}"
msgstr ""

#: src/modules/access/AccessList.tsx
msgid "Create a new access to enable other users or systems to perform actions with this {siteName} account."
msgstr "Cree un nuevo acceso para permitir que otros usuarios o sistemas realicen acciones con esta cuenta de {siteName}."

#: src/modules/disks/DiskList.tsx
msgid "Create a new disk and start storing your data."
msgstr "Cree un nuevo disco y empiece a almacenar sus datos."

#: src/modules/compute/VmList.tsx
#: src/modules/metal/MetalList.tsx
msgid "Create a new resource and get your services running in minutes."
msgstr "Cree un nuevo recurso y ponga sus servicios en marcha en minutos."

#: src/modules/network/NetworkList.tsx
msgid "Create a new resource and start managing your network."
msgstr "Cree un nuevo recurso y empiece a administrar su red."

#: src/modules/services/ServicesList.tsx
msgid "Create a new service and get it running in minutes."
msgstr "Crea un nuevo servicio y ponlo en marcha en minutos."

#: src/modules/api/resourceTypes.tsx
msgid "Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr ""

#: src/modules/storage/StorageList.tsx
msgid "Create a new storage account, create some buckets and start storing your data."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Create a new Virtual Machine or choose something from the App Catalog to get your services running in minutes."
msgstr "Cree una nueva máquina virtual o elija algo del Catálogo de aplicaciones para poner sus servicios en marcha en minutos."

#: src/modules/api/resourceTypes.tsx
msgid "Create a personal Virtual Private Cloud (VPC) and start managing your networks."
msgstr "Cree una VPC (nube privada virtual) personal y empiece a gestionar sus redes."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "Create a public IPv4 address for the resource"
msgstr "Crear una dirección IPv4 pública para el recurso"

#: src/modules/disks/DiskCreate.tsx
msgid "Create additional storage for your workloads. Configure the disk and attach it to a virtual machine now or later."
msgstr ""

#: src/modules/login/Login.tsx
msgid "Create an account"
msgstr "Crear una cuenta"

#: src/modules/api/resourceTypes.tsx
msgid "Create an API Token to use our API."
msgstr "Cree un token de API para usar nuestra API."

#. placeholder {0}: getResourceTypeName(type)
#: src/components/loading/Loading.tsx
msgid "Create another {0}"
msgstr "Crear otro {0}"

#: src/components/forms/CreateBillingAccount.tsx
msgid "Create billing account"
msgstr "Crear cuenta de facturación"

#: src/components/forms/CreateBillingAccount.tsx
#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/CoreServices.tsx
#: src/modules/dashboard/ManagedServices.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateBucketModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/StorageCreate.tsx
#: src/modules/storage/StorageList.tsx
msgid "Create new"
msgstr "Crear nuevo"

#. Created at timestamp
#: src/modules/access/AccessList.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/access/token/TokenView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created"
msgstr "Creado"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Created at"
msgstr "Creado el"

#: src/modules/access/AccessList.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/services/ServicesList.tsx
msgid "Created date"
msgstr "Fecha de creación"

#: src/modules/compute/ModalHeaderBlock.tsx
msgid "Created from"
msgstr "Creada a partir de"

#. Virtual machine status
#: src/components/loading/Loading.tsx
#: src/modules/compute/statusLabels.tsx
msgid "Creating"
msgstr "Creando"

#: src/modules/access/AccessCreate.tsx
msgid "Creating an access by API Token gives you a key to use with our API."
msgstr "Crear un acceso mediante un token de API le proporciona una clave para usar nuestra API."

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Credit"
msgstr "Crédito"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Credit adjustment"
msgstr ""

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Credit is added to this billing account automatically once the payment is received. Make sure the billing account ID is entered correctly."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Credit Note {id}"
msgstr "Nota de crédito {id}"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Current"
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "Current billing cycle"
msgstr ""

#. Explanation: Restoring a snapshot or backup will delete the current state of the virtual machine.
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Current changes will be discarded."
msgstr ""

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Current usage"
msgstr "Uso actual"

#: src/modules/compute/VmSizeSelect.tsx
msgid "Currently not available"
msgstr "Actualmente no disponible"

#. Custom operating system
#: src/modules/compute/os/OsInfo.tsx
#: src/modules/network/firewall/ruleSpec.tsx
msgid "Custom"
msgstr "Personalizado"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Custom ISO image"
msgstr "Imagen ISO personalizada"

#: src/modules/support/WChatProvider.tsx
msgid "Customer support"
msgstr ""

#: src/modules/billing/payment_forms/labels.tsx
msgid "CVC"
msgstr "CVC"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Dark"
msgstr "Oscuro"

#: src/modules/dashboard/Dashboard.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Dashboard"
msgstr "Panel"

#: src/modules/location/LocationDetail.tsx
msgid "Data center where resource is located"
msgstr "Centro de datos donde se encuentra el recurso"

#: src/modules/location/LocationField.tsx
msgid "Data center where the resource will be created."
msgstr "Centro de datos donde se creará el recurso."

#: src/components/forms/WSelect.tsx
msgid "Data missing"
msgstr "Faltan datos"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Date"
msgstr "Fecha"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Declined / Suspended"
msgstr "Rechazado / Suspendido"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/dashboard/BillingAccounts.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Default"
msgstr "Predeterminada"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Default level for post-payment billing accounts"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Delegate access to"
msgstr "Delegar acceso a"

#: src/modules/api/resourceTypes.tsx
msgid "Delegate access to your user or billing account so trusted users can manage your resources."
msgstr "Delegue el acceso a su cuenta de usuario o de facturación para que usuarios de confianza puedan gestionar sus recursos."

#: src/modules/user/ProfileView.tsx
msgid "Delegate new access"
msgstr "Delegar nuevo acceso"

#: src/modules/access/AccessCreate.tsx
msgid "Delegating access to a chosen trusted user enables the user to act as you and perform all operations on behalf of your user or billing account."
msgstr "Delegar el acceso a un usuario de confianza seleccionado le permite actuar como usted y realizar todas las operaciones en nombre de su usuario o de su cuenta de facturación."

#: src/components/button/DeleteButton.tsx
#: src/components/modal/DeleteModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Delete"
msgstr "Eliminar"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Delete floating IP"
msgstr "Eliminar la dirección IP flotante"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
#: src/modules/metal/status/StatusLabels.tsx
msgid "Deleted"
msgstr "Eliminado"

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Al eliminar «{display_name}» se quitará de forma permanente y dejará de estar accesible."

#: src/modules/metal/MetalDeleteModal.tsx
msgid "Deleting \"{display_name}\" would destroy a resource that has already been paid for. Please contact support for assistance."
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
msgid "Deleting \"{name}\" will permanently remove access from all the users in this group to act as you."
msgstr "Al eliminar \"{name}\" se eliminará de forma permanente el acceso de todos los usuarios de este grupo para actuar en su nombre."

#. Items: means files or folders
#. placeholder {0}: files.length
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Deleting {count} {0, plural, one {item} other {items}}."
msgstr "Eliminando {count} {0, plural, one {elemento} other {elementos}}."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a backup will permanently remove it."
msgstr "Eliminar una copia de seguridad la eliminará permanentemente."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a billing account \"{title}\" will remove it permanently. Billing account can be deleted only if there are no unpaid resources attached to it and if it has no unspent credit."
msgstr "Eliminar la cuenta de facturación \"{title}\" la quitará de forma permanente. La cuenta de facturación solo puede eliminarse si no tiene recursos impagos asociados y si no tiene crédito sin utilizar."

#. placeholder {0}: method.name
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting a payment method \"{0}\" will remove it from the billing account."
msgstr "Eliminar el método de pago \"{0}\" lo eliminará de la cuenta de facturación."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting a service will also delete your backups and the service cannot be restored after that."
msgstr "Al eliminar un servicio también se eliminarán sus copias de seguridad y no podrá restaurarse después."

#: src/modules/compute/VmDeleteReplicaModal.tsx
msgid "Deleting a snapshot will permanently remove it."
msgstr "Eliminar una instantánea la eliminará permanentemente."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the access key \"{accessKey}\" will permanently remove it, and it cannot be used for accessing the storage API after that."
msgstr "Eliminar la clave de acceso \"{accessKey}\" la eliminará permanentemente y no podrá utilizarse para acceder a la API de almacenamiento en adelante."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the credit card \"{placeholder}\" will permanently remove it from the billing account."
msgstr "Eliminar la tarjeta de crédito \"{placeholder}\" la quitará de forma permanente de la cuenta de facturación."

#: src/modules/compute/DiskDeleteModal.tsx
msgid "Deleting the disk will permanently remove it, and it will not be accessible after that."
msgstr "Al eliminar el disco, se quitará de forma permanente y no será accesible después."

#. placeholder {0}: name || address
#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Deleting the floating IP address \"{0}\" will remove it from your account and release it to the public pool."
msgstr "Al eliminar la dirección IP flotante \"{0}\", se eliminará de su cuenta y se liberará al grupo público."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Deleting the invoice method will permanently remove it from the billing account."
msgstr "Eliminar el método de pago por factura lo quitará de forma permanente de la cuenta de facturación."

#: src/modules/services/ServiceDeleteModal.tsx
msgid "Deleting the service \"{display_name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Eliminar el servicio «{display_name}» lo eliminará de forma permanente y dejará de ser accesible."

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Deleting the storage account \"{title}\" will permanently remove it and delete all associated keys. Accounts with active buckets cannot be deleted."
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Deleting the storage bucket \"{name}\" will permanently remove it, and any files in it will not be accessible after that."
msgstr "Eliminar el bucket de almacenamiento \"{name}\" lo eliminará de forma permanente, y los archivos que contiene dejarán de ser accesibles."

#: src/modules/access/token/TokenView.tsx
msgid "Deleting the token \"{description}\" will permanently remove it, and it cannot be used for authentication after that."
msgstr "Al eliminar el token \"{description}\", se eliminará de forma permanente y ya no podrá usarse para autenticarse."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine \"{name}\" will permanently remove it, and it will not be accessible after that."
msgstr "Al eliminar la máquina virtual \"{name}\", se eliminará de forma permanente y dejará de ser accesible."

#: src/modules/compute/VmDeleteModal.tsx
msgid "Deleting the virtual machine will also delete your backups and snapshots, and the machine cannot be restored after that. If you wish to keep the backups and snapshots consider stopping the machine instead."
msgstr "Al eliminar la máquina virtual también se eliminarán sus copias de seguridad e instantáneas, y la máquina no podrá restaurarse. Si desea conservar las copias de seguridad y las instantáneas, considere detener la máquina en su lugar."

#: src/modules/network/vpc/VpcView.tsx
msgid "Deleting the VPC network \"{name}\" will remove it from your account."
msgstr "Al eliminar la red VPC \"{name}\", se eliminará de su cuenta."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Description"
msgstr "Descripción"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Destinations"
msgstr "Destinos"

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/UnattachedItem.tsx
msgid "Detached"
msgstr "Desasociado"

#: src/modules/compute/VmView.tsx
msgid "Disable"
msgstr "Desactivar"

#: src/modules/compute/VmView.tsx
msgid "Disable backups"
msgstr "Desactivar copias de seguridad"

#: src/modules/user/ProfileView.tsx
msgid "Disable MFA"
msgstr "Desactivar MFA"

#: src/components/EnabledDisabled.tsx
msgid "Disabled"
msgstr "Desactivado"

#: src/modules/compute/WVnc.tsx
msgid "Disconnect"
msgstr "Desconectar"

#. State of connection: Not connected
#: src/modules/compute/WVnc.tsx
msgid "Disconnected"
msgstr "Desconectado"

#. Column title for invoice records' discount
#: src/components/PriceWithDiscount.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Discount"
msgstr "Descuento"

#: src/modules/api/resourceTypes.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Disk"
msgstr "Disco"

#: src/modules/compute/MetricsGrid.tsx
msgid "Disk I/O"
msgstr "E/S de disco"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
msgid "Disk size can only be increased. This action is not reversible. Minimum disk size:"
msgstr "El tamaño del disco solo se puede aumentar. Esta acción no es reversible. Tamaño mínimo del disco:"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
msgid "Disks"
msgstr "Discos"

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/CurrencyModal.tsx
msgid "Display currency"
msgstr "Moneda de visualización"

#: src/modules/storage/StorageCreate.tsx
msgid "Display name"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Document"
msgstr "Documento"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Document file"
msgstr "Archivo del documento"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Document No."
msgstr "N.º de documento"

#. Button action to download a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Download"
msgstr "Descargar"

#: src/modules/services/Access.tsx
msgid "Download config file"
msgstr "Descargar archivo de configuración"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Download PDF"
msgstr "Descargar PDF"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Drop files here"
msgstr "Suelte los archivos aquí"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Due date"
msgstr "Fecha de vencimiento"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "E-mail"
msgstr "Correo electrónico"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit"
msgstr "Editar"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Edit \"{title}\""
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Edit maintenance"
msgstr "Editar mantenimiento"

#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Edit name"
msgstr ""

#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Edit node"
msgstr "Editar nodo"

#: src/modules/network/firewall/EditRuleModal.tsx
msgid "Edit rule"
msgstr "Editar regla"

#. Field label
#: src/components/EditableList.tsx
#: src/modules/login/Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Email"
msgstr "Correo electrónico"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Email domain is prohibited"
msgstr ""

#: src/modules/login/Login.tsx
msgid "Email verification failed"
msgstr "Error al verificar el correo electrónico"

#: src/modules/login/Login.tsx
msgid "Email verified"
msgstr "Correo electrónico verificado"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Email where invoices and reports are sent."
msgstr "Correo electrónico al que se enviarán las facturas y los informes."

#: src/modules/compute/VmCreate.tsx
msgid "Empty disk (for ISO booting)"
msgstr "Disco vacío (para el arranque desde ISO)"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Enable"
msgstr "Activar"

#: src/modules/user/ProfileView.tsx
msgid "Enable MFA"
msgstr "Activar MFA"

#: src/modules/access/AccessCreate.tsx
msgid "Enable other users or systems to perform actions with resources connected to this account."
msgstr "Permita que otros usuarios o sistemas realicen acciones con los recursos conectados a esta cuenta."

#: src/components/EnabledDisabled.tsx
msgid "Enabled"
msgstr "Activado"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "End date"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "End port"
msgstr ""

#: src/modules/network/firewall/validatePorts.ts
msgid "End port must be greater than start port"
msgstr ""

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Ended"
msgstr ""

#: src/modules/compute/AddSubInterfaceModal.tsx
msgid "Enter a value between 1 and 4094"
msgstr "Introduzca un valor entre 1 y 4094"

#. Card security code validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Enter digits only"
msgstr ""

#. placeholder {0}: currency.title
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Enter the top up amount in {0} (minimum {minimumAmount}):"
msgstr "Ingrese el monto de la recarga en {0} (mínimo {minimumAmount}):"

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/error/Isolated.tsx
#: src/modules/login/Login.tsx
#: src/modules/notifications/toast.tsx
msgid "Error"
msgstr "Error"

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Error adding payment method"
msgstr "Error al agregar el método de pago"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Error code: {code}"
msgstr ""

#: src/components/button/WButton.tsx
msgid "Error performing action"
msgstr "Error al realizar la acción"

#: src/modules/notifications/toast.tsx
msgid "Error saving changes"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Est. cost per backup"
msgstr ""

#: src/components/table/DetailsTableMonthlyCost.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Est. monthly cost"
msgstr "Costo mensual estimado"

#. Short of: Estimated
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Est. total"
msgstr "Total estimado"

#: src/components/forms/MonthlyCostField.tsx
msgid "Estimated cost"
msgstr ""

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per backup is {priceWithDiscount} per month."
msgstr ""

#: src/modules/pricing/ReplicaPrice.tsx
msgid "Estimated price per snapshot is {priceWithDiscount} per month."
msgstr ""

#. Table column: what happened to the billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Event"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user receives a {c_totalReceiverCredit} worth of free credits when signing up through the referral link or code and adding a verified payment method."
msgstr "Cada usuario nuevo recibe créditos gratuitos por un valor de {c_totalReceiverCredit} al registrarse mediante el enlace o código de referido y agregar un método de pago verificado."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Every new user who signs up through the referral program and tops up at least {c_minimumTopUp} will receive a bonus worth of {c_totalReceiverCredit} credits."
msgstr "Cada usuario nuevo que se registre a través del programa de referidos y recargue al menos {c_minimumTopUp} recibirá una bonificación por un valor de {c_totalReceiverCredit} en créditos."

#: src/modules/compute/SubInterfaceModal.tsx
msgid "Example"
msgstr "Ejemplo"

#: src/modules/currency/CurrencyModal.tsx
#: src/modules/currency/DisplayCurrencyRate.tsx
msgid "Exchange rate"
msgstr "Tipo de cambio"

#. Short of: Excluding (VAT/GST etc.)
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Excl. {vatSymbol}"
msgstr "Sin {vatSymbol}"

#. The number of fail-over nodes:
#: src/modules/services/ServiceCreate.tsx
msgid "Fail-over nodes"
msgstr "Nodos de conmutación por error"

#: src/modules/api/ApiError.ts
msgid "Failed to connect to server"
msgstr ""

#: src/modules/billing/account_validation/digio/utils.ts
msgid "Failed to load Digio library"
msgstr ""

#: src/modules/billing/paypal/utils.ts
msgid "Failed to load PayPal library"
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Failed to open popup, possible popup blocker usage"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "File"
msgstr "Archivo"

#: src/modules/storage/bucket/BucketView.tsx
msgid "Files"
msgstr "Archivos"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Files will be uploaded to"
msgstr "Los archivos se subirán a"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "Firewall"
msgstr "Cortafuegos"

#: src/modules/network/NetworkCreate.tsx
msgid "Firewall is available at no additional cost."
msgstr "El cortafuegos está disponible sin costo adicional."

#: src/modules/compute/VmView.tsx
msgid "Firewall name"
msgstr "Nombre del firewall"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Firewall now available"
msgstr "El cortafuegos ya está disponible"

#: src/modules/user/ProfileView.tsx
msgid "First name"
msgstr "Nombre"

#: src/modules/services/ConnectionDetails.tsx
msgid "Flags"
msgstr "Indicadores"

#: src/modules/api/resourceTypes.tsx
msgid "Floating IP"
msgstr "Dirección IP flotante"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder"
msgstr "Carpeta"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Folder name"
msgstr "Nombre de la carpeta"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up through the referral program and tops up at least {c_minimumTopUp}, you will receive {c_promoterCredit} worth of free credits."
msgstr "Por cada usuario nuevo que se registre a través del programa de referidos y recargue al menos {c_minimumTopUp}, usted recibirá créditos gratuitos por un valor de {c_promoterCredit}."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "For every new user who signs up using your referral code and adds a verified payment method, you will receive {c_promoterCredit} worth of free credits."
msgstr "Por cada usuario nuevo que se registre usando su código de referido y agregue un método de pago verificado, recibirá créditos gratuitos por un valor de {c_promoterCredit}."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "For pay-as-you-go billing account you can select the payment method after the account is created and validated."
msgstr "En una cuenta de facturación de pago por uso, puede seleccionar el método de pago después de que la cuenta se haya creado y validado."

#: src/modules/compute/labels.tsx
msgid "For the snapshots you will only pay for the storage used by the snapshot."
msgstr "Por las instantáneas solo pagará el almacenamiento que utilicen."

#. Unsafely shut down the virtual machine
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Force stop"
msgstr "Forzar apagado"

#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
msgid "Forgot password"
msgstr "¿Olvidó su contraseña?"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Forwarding rules"
msgstr "Reglas de reenvío"

#. At no cost. | POS: Noun
#: src/components/forms/MonthlyCostField.tsx
msgid "Free"
msgstr "Gratis"

#: src/modules/compute/VmView.tsx
#: src/modules/services/Backups.tsx
msgid "Frequency"
msgstr "Frecuencia"

#: src/modules/services/ServicesList.tsx
msgid "from"
msgstr "desde"

#: src/modules/compute/VmCreate.tsx
msgid "From"
msgstr "Desde"

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Frozen"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Full path"
msgstr "Ruta completa"

#: src/modules/services/ServiceView.tsx
msgid "Fully managed database so you can focus on your code."
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Fully managed services - we handle the provisioning of underlying infrastructure and the management of the service."
msgstr "Servicios totalmente gestionados: nosotros nos encargamos del aprovisionamiento de la infraestructura subyacente y de la gestión del servicio."

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Future"
msgstr ""

#. Payment gateway that the card is connected to
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Gateway"
msgstr "Pasarela"

#. unit: gigabytes
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/l10n/units.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "GB"
msgstr "GB"

#. Example: 50 GB (of) disk
#: src/modules/l10n/units.tsx
msgid "GB disk"
msgstr "GB de disco"

#. Example: 16 GB (of) RAM
#: src/modules/compute/VmSizeSelect.tsx
#: src/modules/l10n/units.tsx
msgid "GB RAM"
msgstr "GB de RAM"

#. unit: gigabyte-hours (storage usage)
#: src/modules/l10n/units.tsx
msgid "GBh"
msgstr "GBh"

#. Explanation: Generate the subnet range automatically
#: src/modules/network/NetworkCreate.tsx
msgid "Generate (recommended)"
msgstr ""

#: src/modules/access/AccessCreate.tsx
msgid "Generate an API access token to use our <0>API</0>."
msgstr "Genere un token de acceso a la API para usar nuestra <0>API</0>."

#: src/modules/access/scopeLabel.tsx
msgid "Global"
msgstr "Global"

#: src/modules/error/ErrorFallback.tsx
msgid "Go to dashboard"
msgstr ""

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST"
msgstr "GST"

#. Sales tax acronym in India
#: src/styles/hostzop/theme.tsx
msgid "GST number"
msgstr "Número GST"

#. unit: hours
#: src/modules/l10n/units.tsx
msgid "h"
msgstr "h"

#. Chat widget greeting
#: src/modules/support/WChatProvider.tsx
msgid "Hello"
msgstr ""

#: src/routes/_main_custom/about.lazy.tsx
msgid "Hello world!"
msgstr "¡Hola, mundo!"

#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Hibernate"
msgstr "Hibernar"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernated"
msgstr "Hibernado"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Hibernating"
msgstr "Hibernando"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Hide"
msgstr "Ocultar"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Hide details"
msgstr "Ocultar detalles"

#: src/modules/api/resourceTypes.tsx
msgid "High availability load balancer distributes traffic between virtual machines within the same data center location."
msgstr "Un balanceador de carga de alta disponibilidad distribuye el tráfico entre máquinas virtuales dentro de la misma ubicación del centro de datos."

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/period.tsx
msgid "hour"
msgstr "hora"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Hourly"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Hourly billing cycle only"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Hourly updated usage for current billing period."
msgstr "Uso actualizado cada hora para el período de facturación actual."

#: src/modules/dashboard/UserAccess.tsx
msgid "I can access"
msgstr "Puedo acceder"

#: src/modules/login/ConsentForm.tsx
msgid "I have read and agree to the <0>Terms of Service</0>"
msgstr "He leído y acepto los <0>Términos del servicio</0>"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "I'm aware that deletion is permanent"
msgstr "Entiendo que la eliminación es permanente"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "If low balance notifications are active and the balance falls below the threshold, you will be notified."
msgstr "Si las notificaciones de saldo bajo están activas y el saldo cae por debajo del umbral, se le notificará."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "If the active reservation runs out and is not renewed then standard hourly based pricing will be applied."
msgstr ""

#: src/modules/billing/choose_method/InvoiceForm.tsx
msgid "If the invoice payment method is not activated instantly, we will contact you with more details. If you do not receive an email from us soon or the invoice payment does not become active, you can contact us at <0/>."
msgstr "Si el método de pago por factura no se activa de inmediato, nos pondremos en contacto con usted con más detalles. Si no recibe un correo electrónico de nuestra parte pronto o el pago por factura no se activa, puede contactarnos en <0/>."

#: src/modules/dashboard/Dashboard.tsx
msgid "If you have any questions, found a bug or have a feature request feel free to contact us through <0>support</0>."
msgstr "Si tiene alguna pregunta, ha encontrado un error o desea solicitar una función, no dude en contactarnos a través del <0>soporte</0>."

#. Description for billing period field
#: src/modules/metal/offer/period.tsx
msgid "In all calculations a precise number of hours is used: 730 for a month, 2190 for a quarter and 8760 for a year."
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "In use"
msgstr "En uso"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Inactive"
msgstr "Inactivo"

#. Short of: inbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "inbound"
msgstr "entrante"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Inbound rules"
msgstr "Reglas de entrada"

#. The price has already been included in the virtual machine's price
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Included in VM price"
msgstr ""

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other traffic will be blocked."
msgstr "El tráfico entrante solo está permitido a los puertos especificados si se origina en las fuentes especificadas. Todo el resto del tráfico se bloqueará."

#: src/modules/compute/VmCreate.tsx
msgid "Informative name. It will also be used to generate a suitable hostname for the VM (if applicable)."
msgstr "Nombre descriptivo. También se utilizará para generar un nombre de host adecuado para la máquina virtual (si corresponde)."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/ServiceView.tsx
msgid "Infrastructure"
msgstr "Infraestructura"

#: src/modules/compute/VmCreate.tsx
msgid "Initialization script"
msgstr "Script de inicialización"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Insert code"
msgstr "Insertar código"

#: src/modules/access/AccessCreate.tsx
msgid "Insert email of the {siteName} user you want to delegate access to. The user will need to accept the access invitation from their profile view."
msgstr "Introduzca el correo electrónico del usuario de {siteName} al que desea delegar acceso. El usuario deberá aceptar la invitación de acceso desde su vista de perfil."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Insufficient funds"
msgstr "Fondos insuficientes"

#. Field label: identifier used to connect a billing account to an external integration
#. Unique ID number to integrate with external services
#: src/modules/billing/billingAccount/fieldsInfo.tsx
#: src/styles/defaultTheme.tsx
msgid "Integration ID"
msgstr "ID de integración"

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid month"
msgstr ""

#: src/modules/api/ApiError.ts
msgid "Invalid response from server. Blocked by Stormwall."
msgstr ""

#: src/modules/api/ApiError.ts
msgid "Invalid response type from server: Received {ct} instead of JSON."
msgstr ""

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Invalid signup. The account may already exist."
msgstr ""

#. Card expiration validation error
#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "Invalid year"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/invoice/DownloadPdf.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice"
msgstr "Factura"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Invoice {id}"
msgstr "Factura {id}"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Invoice details"
msgstr "Detalles de la factura"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Invoice email"
msgstr "Correo electrónico de facturación"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice has been paid"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Invoice is not payable"
msgstr ""

#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Invoice name"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Invoice payment"
msgstr ""

#: src/components/themeTrans.tsx
msgid "Invoices"
msgstr "Facturas"

#: src/modules/services/IpWhitelist.tsx
msgid "IP"
msgstr "IP"

#: src/modules/services/AddIpForm.tsx
msgid "IP address"
msgstr "Dirección IP"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "IP address or CIDR range"
msgstr ""

#. A list of IPs permitted to access the service | Legacy wording: IP whitelist
#: src/modules/services/IpWhitelist.tsx
#: src/modules/services/ServiceView.tsx
msgid "IP allowlist"
msgstr "Lista de direcciones IP permitidas"

#: src/modules/network/firewall/ruleSpec.tsx
msgid "IP prefixes"
msgstr "Prefijos IP"

#: src/modules/network/NetworkCreate.tsx
msgid "IP range"
msgstr ""

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv4 range"
msgstr "Rango IPv4"

#: src/modules/network/vpc/VpcView.tsx
msgid "IPv6 range"
msgstr "Rango IPv6"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "ISO boot"
msgstr "Arranque desde ISO"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Issue date"
msgstr "Fecha de emisión"

#. Date the invoice was issued
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Issued"
msgstr "Emitida"

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "Keep floating IP"
msgstr "Conservar la dirección IP flotante"

#: src/modules/user/ActAsModal.tsx
msgid "Keep in mind that all the actions will be tracked and can be traced back to you."
msgstr "Tenga en cuenta que todas las acciones se registrarán y podrán atribuirse a usted."

#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/UpdateKeyModal.tsx
msgid "Key name"
msgstr ""

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Kubernetes Patch Version"
msgstr "Versión de parche de Kubernetes"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Kubernetes Patch Version Auto update"
msgstr "Actualización automática de la versión de parche de Kubernetes"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Kubernetes service can not be created."
msgstr "No se puede crear el servicio de Kubernetes."

#: src/modules/l10n/LocaleButton.tsx
msgid "Language"
msgstr "Idioma"

#: src/modules/network/vpc/VpcView.tsx
msgid "Last modified"
msgstr "Última modificación"

#: src/modules/user/ProfileView.tsx
msgid "Last name"
msgstr "Apellido"

#: src/modules/compute/VmView.tsx
msgid "Latest backup"
msgstr "Copia de seguridad más reciente"

#. Timestamp of latest snapshot
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/services/Backups.tsx
msgid "Latest snapshot"
msgstr "Instantánea más reciente"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Less details"
msgstr "Menos detalles"

#: src/modules/main/ColorSchemeMenu.tsx
msgid "Light"
msgstr "Claro"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Limit will be removed once the total top up amount reaches <0/>."
msgstr "El límite se eliminará cuando el importe total de las recargas alcance <0/>."

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Limited"
msgstr "Limitada"

#. Column title for invoice records' totals - record amount subtracted by discount
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Line total"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Linked resources"
msgstr "Recursos vinculados"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "list price"
msgstr "precio de lista"

#: src/modules/api/resourceTypes.tsx
msgid "Load balancer"
msgstr "Balanceador de carga"

#. Button action: load the next rows of the list
#: src/modules/billing/statusHistory/StatusHistory.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Load more"
msgstr "Cargar más"

#: src/modules/billing/progressLabels.tsx
msgid "Loading payment provider"
msgstr "Cargando el proveedor de pagos"

#: src/components/forms/WSelect.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Loading..."
msgstr "Cargando..."

#: src/modules/compute/VmList.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/location/LocationDetail.tsx
#: src/modules/location/LocationField.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/pricing/PricingModal.tsx
#: src/modules/services/ServicesList.tsx
msgid "Location"
msgstr "Ubicación"

#: src/modules/login/ApiKeyLogin.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/Login.tsx
#: src/modules/login/LoginLayout.tsx
msgid "Log in"
msgstr "Iniciar sesión"

#: src/modules/login/Login.tsx
msgid "Log in with Google"
msgstr "Iniciar sesión con Google"

#: src/modules/main/LogoutConfirmDialog.tsx
#: src/modules/user/LogoutButton.tsx
#: src/modules/user/UserMenu.tsx
msgid "Log out"
msgstr "Cerrar sesión"

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Logging in"
msgstr ""

#: src/modules/login/auth0/Auth0Login.tsx
msgid "Login error"
msgstr ""

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Look around first"
msgstr "Eche un vistazo primero"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Low balance notification is not in effect because automated top up is activated."
msgstr "La notificación de saldo bajo no surte efecto porque la recarga automática está activada."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Low balance notifications"
msgstr "Notificaciones por saldo bajo"

#. MAC address
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
msgid "MAC"
msgstr "MAC"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Machine details"
msgstr "Detalles de la máquina"

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is available for immediate leasing by clients."
msgstr "La máquina está disponible para arrendamiento inmediato por los clientes."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is being used by client and is being charged."
msgstr "La máquina está siendo utilizada por el cliente y se está facturando."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is ordered by client, but does not satisfy the required configuration.<0/>After it has been configured as needed, move to “in use” status."
msgstr "La máquina ha sido solicitada por el cliente, pero no cumple con la configuración requerida.<0/>Una vez configurada según sea necesario, cámbiela al estado «en uso»."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine is unavailable or requires repairs."
msgstr "La máquina no está disponible o requiere reparaciones."

#: src/modules/metal/status/StatusLabels.tsx
msgid "Machine requires disk cleaning operations."
msgstr "La máquina requiere operaciones de limpieza de discos."

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Machine type"
msgstr "Tipo de máquina"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
#: src/modules/services/ServiceView.tsx
msgid "Maintenance"
msgstr "Mantenimiento"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/UserMenu.tsx
msgid "Manage"
msgstr "Administrar"

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Manage API keys"
msgstr "Administrar claves de API"

#: src/modules/api/resourceTypes.tsx
msgid "Managed service"
msgstr "Servicio gestionado"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Managed services"
msgstr "Servicios gestionados"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
msgid "Max. surge"
msgstr "Aumento máx."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Maximize"
msgstr "Maximizar"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Maximum upload file size is {maxFileSizeInMB} MB"
msgstr "El tamaño máximo del archivo a cargar es {maxFileSizeInMB} MB"

#. unit: megabytes
#: src/modules/l10n/units.tsx
msgid "MB"
msgstr "MB"

#. unit: megabytes per second
#: src/modules/l10n/units.tsx
msgid "MB/s"
msgstr "MB/s"

#. unit: megabits per second
#: src/modules/l10n/units.tsx
msgid "Mbit/s"
msgstr "Mbit/s"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Method"
msgstr "Método"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Methods available after validation"
msgstr "Métodos disponibles después de la validación"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/services/Metrics.tsx
#: src/modules/services/ServiceView.tsx
msgid "Metrics"
msgstr "Métricas"

#: src/modules/compute/monitor/MetricChart.tsx
msgid "Metrics for this resource are not loaded for performance reasons"
msgstr "Las métricas de este recurso no se cargan por motivos de rendimiento"

#: src/modules/user/ProfileView.tsx
msgid "MFA is active for your user."
msgstr "La autenticación multifactor está activa para su usuario."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Minimize"
msgstr "Minimizar"

#. The selected item was not found
#: src/components/forms/WSelect.tsx
msgid "Missing"
msgstr "No encontrado"

#. If the disk is a boot disk
#: src/modules/compute/VmView.tsx
msgid "Mode"
msgstr "Modo"

#. Time period unit
#: src/components/forms/MonthlyCostField.tsx
#: src/modules/metal/offer/MetalOfferSection.tsx
#: src/modules/metal/offer/period.tsx
msgid "month"
msgstr "mes"

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Monthly"
msgstr ""

#: src/components/sidebar/PriceBlock.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/StorageList.tsx
msgid "Monthly cost"
msgstr "Costo mensual"

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "More details"
msgstr "Más detalles"

#: src/modules/user/ProfileView.tsx
msgid "Multi-factor authentication (MFA)"
msgstr "Autenticación multifactor (MFA)"

#: src/modules/billing/forms/BillingSelect.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "N/A"
msgstr "N/D"

#: src/components/table/DetailsTableName.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingList.tsx
#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/compute/UpdateSshKeyModal.tsx
#: src/modules/compute/VmList.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/metal/MetalList.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServicesList.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
#: src/modules/user/ProfileView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Name"
msgstr "Nombre"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name (Min {minChars} chars)"
msgstr "Nombre (mín. {minChars} caracteres)"

#: src/modules/billing/payment_forms/components.tsx
msgid "Name is too short"
msgstr "El nombre es demasiado corto"

#: src/modules/support/WChatProvider.tsx
msgid "Need help?"
msgstr ""

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/network/NetworkList.tsx
msgid "Network"
msgstr "Red"

#: src/modules/compute/MetricsGrid.tsx
msgid "Network bandwidth"
msgstr "Ancho de banda de red"

#: src/modules/compute/VmView.tsx
msgid "Network interfaces"
msgstr "Interfaces de red"

#: src/modules/compute/VmView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Networking"
msgstr "Redes"

#. Table column: value after the change
#: src/components/sidebar/SidebarList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/NetworkList.tsx
msgid "New"
msgstr "Nuevo"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New file name"
msgstr "Nombre del nuevo archivo"

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder"
msgstr "Nueva carpeta"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "New folder name"
msgstr "Nombre de la nueva carpeta"

#: src/modules/network/VpcNetworkSelect.tsx
msgid "New network"
msgstr "Nueva red"

#: src/modules/compute/PasswordFields.tsx
msgid "New password"
msgstr "Nueva contraseña"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "New SSH key"
msgstr "Nueva clave SSH"

#: src/styles/nforce/theme.tsx
msgid "NForce customer ID"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "No active card"
msgstr "No hay tarjeta activa"

#. Chart empty state: no metric samples are available
#: src/modules/compute/monitor/MetricChart.tsx
msgid "No data"
msgstr ""

#. Fail-over is disabled, no fail-over nodes
#: src/modules/services/FailoverNodeSelect.tsx
msgid "No Fail-over"
msgstr ""

#. Shown when the billing account status history is empty
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No history available."
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "No one can access your user account yet"
msgstr "Nadie puede acceder a su cuenta de usuario todavía"

#: src/modules/dashboard/UserAccess.tsx
msgid "No one has shared access with you yet"
msgstr "Nadie ha compartido acceso con usted todavía"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "No payment will be made currently. You can change your payment method at any time."
msgstr "No se realizará ningún pago por ahora. Puede cambiar su método de pago en cualquier momento."

#: src/components/empty.tsx
msgid "No records"
msgstr "Sin registros"

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "No reservation billing cycles are available for this server."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "No restrictions"
msgstr ""

#: src/components/sidebar/EmptyItem.tsx
#: src/modules/dashboard/AppCatalog.tsx
#: src/modules/dashboard/ManagedServices.tsx
msgid "No results found"
msgstr "No se encontraron resultados"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "No verified primary payment method"
msgstr ""

#. Short of: Number of storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "No. of buckets"
msgstr ""

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "No. of files"
msgstr "N.º de archivos"

#. Short of: Number of resources
#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/NetworkList.tsx
msgid "No. of resources"
msgstr "N.º de recursos"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
msgid "No. of rules"
msgstr "N.º de reglas"

#: src/modules/services/Backups.tsx
#: src/modules/services/Metrics.tsx
msgid "Node"
msgstr "Nodo"

#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "Node pool"
msgstr "Grupo de nodos"

#: src/modules/services/ServiceCreate.tsx
msgid "Node pools"
msgstr "Grupos de nodos"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "nodes"
msgstr "nodos"

#. Items: means files or folders
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If you are deleting substantial number of items, the deletion process may result in an inconsistent state, where some items are deleted while others remain. In the event of such occurrences, please repeat the same action again."
msgstr "Nota: Si está eliminando una cantidad considerable de elementos, el proceso de eliminación puede provocar un estado inconsistente, en el que algunos elementos se eliminen mientras que otros permanezcan. Si esto ocurre, repita la misma acción nuevamente."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Note: If your folder contains a substantial number of files, the renaming process will take time and may result in an inconsistent state where some files are moved to a new location, while others remain in the old folder. In the event of such occurrences, please repeat the action by renaming the same folder once more."
msgstr "Nota: Si su carpeta contiene una cantidad considerable de archivos, el proceso de cambio de nombre llevará tiempo y puede provocar un estado inconsistente en el que algunos archivos se muevan a una nueva ubicación, mientras que otros permanezcan en la carpeta anterior. Si esto ocurre, repita la acción cambiando el nombre de la misma carpeta una vez más."

#: src/modules/access/AcceptInvitationModal.tsx
msgid "Note! The owner will know if you have accepted this invitation. They will not be able to access your user account and see or edit any of your resources."
msgstr "Nota: El propietario sabrá si ha aceptado esta invitación. No podrá acceder a su cuenta de usuario ni ver o editar ninguno de sus recursos."

#: src/modules/notifications/NotificationMenu.tsx
msgid "Notifications"
msgstr "Notificaciones"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Notify when balance goes below"
msgstr "Notificar cuando el saldo sea inferior a"

#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Notify when balance goes below the following threshold. Keep in mind that the actual limit is defined in base currency."
msgstr "Notificar cuando el saldo baje del siguiente umbral. Tenga en cuenta que el límite real se define en la moneda base."

#. Availability announcement for AMD EPYC cloud resources
#: src/styles/readyidc/theme.tsx
msgid "Now available"
msgstr ""

#: src/modules/metal/status/StatusLabels.tsx
msgid "Offline"
msgstr "Sin conexión"

#. Table column: value before the change
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Old"
msgstr ""

#. Backup frequency
#: src/modules/services/Backups.tsx
msgid "Once a day"
msgstr "Una vez al día"

#: src/modules/compute/VmView.tsx
msgid "Once a week (Wednesday at 02:00 UTC)"
msgstr "Una vez por semana (miércoles a las 02:00 UTC)"

#: src/modules/storage/account/SuspendedNotice.tsx
msgid "One of your billing accounts has a problem and your buckets have been suspended. See <0>billing account details</0> for more information or contact support to resolve the issue."
msgstr "Una de sus cuentas de facturación tiene un problema y sus buckets han sido suspendidos. Consulte <0>los detalles de la cuenta de facturación</0> para obtener más información o póngase en contacto con soporte para resolver el problema."

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
msgid "Ongoing"
msgstr "En curso"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Ongoing balance"
msgstr "Saldo en curso"

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
msgid "Online"
msgstr "En línea"

#. Only payment methods that can be charged automatically
#: src/modules/billing/choose_method/ChooseMethod.tsx
msgid "Only automated methods"
msgstr "Solo métodos automáticos"

#: src/modules/compute/VmCreate.tsx
msgid "Only the boot disk will be created! This may cause the OS to not boot properly if the configuration in the OS of source snapshot requires additional disks to be present."
msgstr "¡Solo se creará el disco de arranque! Esto puede provocar que el SO no se inicie correctamente si la configuración del SO de la instantánea de origen requiere discos adicionales."

#: src/modules/compute/labels.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Operating system"
msgstr "Sistema operativo"

#: src/modules/services/kubernetes/Maintenance.tsx
msgid "Operating system Auto update"
msgstr "Actualización automática del sistema operativo"

#: src/modules/login/Login.tsx
msgid "Or"
msgstr ""

#: src/styles/dataxion/theme.tsx
msgid "Order"
msgstr "Pedido"

#: src/styles/dataxion/theme.tsx
msgid "Orders"
msgstr "Pedidos"

#. Short of: Operating system
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "OS"
msgstr "SO"

#. Short of: outbound firewall rules
#: src/modules/network/NetworkList.tsx
msgid "outbound"
msgstr "saliente"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Outbound rules"
msgstr "Reglas de salida"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be blocked."
msgstr "El tráfico saliente solo está permitido hacia los puertos especificados de los destinos especificados. Todo el resto del tráfico se bloqueará."

#: src/modules/billing/BillingList.tsx
msgid "Outstanding amount"
msgstr "Importe pendiente"

#: src/modules/billing/ReportStatus.tsx
msgid "Paid"
msgstr "Pagado"

#: src/modules/services/ConnectionDetails.tsx
msgid "Parameters"
msgstr "Parámetros"

#: src/modules/compute/PasswordFields.tsx
#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/user/ProfileView.tsx
msgid "Password"
msgstr "Contraseña"

#: src/modules/compute/PasswordFields.tsx
msgid "Password for the user. Must contain at least one lowercase and one uppercase ASCII letter (a-z, A-Z) and at least one digit (0-9). Minimum length is 8 characters."
msgstr "Contraseña del usuario. Debe contener al menos una letra ASCII minúscula y una mayúscula (a-z, A-Z) y al menos un dígito (0-9). La longitud mínima es de 8 caracteres."

#: src/modules/compute/PasswordFields.tsx
msgid "Passwords do not match"
msgstr "Las contraseñas no coinciden"

#. Metal coverage status
#: src/modules/metal/statusLabels.tsx
msgid "Past"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Path style URL"
msgstr "URL de estilo ruta"

#. Button action: pay for unpaid invoice
#: src/modules/billing/ActionButtons.tsx
msgid "Pay"
msgstr ""

#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Pay invoice"
msgstr "Pagar factura"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Pay now"
msgstr "Pagar ahora"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Pay the total charge amount of <0>{chargeAmount}</0> with EVC Mobile Money to get {creditAmount} credits. Enter your billing account ID <1>{billingAccountId}</1> as the payment reference."
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Pay-as-you-go (recommended)"
msgstr "Pago por uso (recomendado)"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/paymentMethodLogic.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Paying by invoice"
msgstr "Pago por factura"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (declined / suspended)"
msgstr "Pago por factura (rechazado/suspendido)"

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Paying by invoice (pending)"
msgstr "Pago por factura (pendiente)"

#: src/modules/billing/PaymentReturn.tsx
msgid "Payment authorization check finished."
msgstr "La verificación de la autorización de pago ha finalizado."

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled"
msgstr ""

#: src/modules/billing/sslcommerz/parseSslcommerzPersistentData.ts
msgid "Payment cancelled due to high risk"
msgstr ""

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment details"
msgstr "Detalles de pago"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment error"
msgstr ""

#: src/modules/billing/payment/paymentUtils.ts
msgid "Payment error: {failure_message}{codeSuffix}"
msgstr ""

#: src/modules/billing/clictopay/parseClictopayPaymentResult.ts
#: src/modules/billing/coingate/parseCoingatePaymentResult.ts
#: src/modules/billing/paypal/parsePaypalCheckoutPaymentResult.tsx
#: src/modules/billing/razorpay/parseRazorpayPersistentData.ts
msgid "Payment failed"
msgstr ""

#. What caused the billing account status change
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Payment method"
msgstr "Método de pago"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Payment methods"
msgstr "Métodos de pago"

#: src/modules/billing/payment_forms/components.tsx
msgid "Payment processing with this method takes some time. Purchased credit will be automatically added to your account once the process is complete."
msgstr "El procesamiento del pago con este método toma algo de tiempo. El crédito adquirido se agregará automáticamente a su cuenta una vez que el proceso se complete."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Payment type"
msgstr "Tipo de pago"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Payment was cancelled"
msgstr ""

#. unit: pieces
#: src/modules/l10n/units.tsx
msgid "pc"
msgstr "ud"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/metal/status/StatusLabels.tsx
#: src/modules/user/ProfileView.tsx
msgid "Pending"
msgstr "Pendiente"

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Pending validation"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Period"
msgstr "Período"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Permissions"
msgstr "Permisos"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Personal ID number"
msgstr "Número de identificación personal"

#: src/modules/billing/omise/OmisePaymentForm.tsx
#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "Phone number"
msgstr "Número de teléfono"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Platform provided"
msgstr "Proporcionado por la plataforma"

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "Please acknowledge that billing account will not be activated before an administrator has accepted your request."
msgstr "Por favor, tenga en cuenta que la cuenta de facturación no se activará hasta que un administrador haya aceptado su solicitud."

#: src/modules/billing/choose_method/useAddMethod.tsx
msgid "Please allow popup windows to use this payment method"
msgstr "Permita las ventanas emergentes para usar este método de pago"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Please be patient"
msgstr "Por favor, tenga paciencia"

#: src/modules/billing/progressLabels.tsx
msgid "Please complete the payment in the popup window"
msgstr "Complete el pago en la ventana emergente"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "Please contact support to remove the limit."
msgstr "Póngase en contacto con soporte para eliminar el límite."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please contact the administrators for further details."
msgstr "Póngase en contacto con los administradores para más detalles."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Please continue."
msgstr "Por favor, continúe."

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Please enter a valid name"
msgstr "Introduzca un nombre válido"

#: src/modules/login/Login.tsx
msgid "Please enter your email address. We will send you an email to reset your password."
msgstr "Ingrese su dirección de correo electrónico. Le enviaremos un correo para restablecer su contraseña."

#: src/modules/access/AccessCreate.tsx
msgid "Please finish adding the email"
msgstr "Termine de agregar el correo electrónico"

#: src/modules/storage/bucket/bucketMessages.tsx
msgid "Please note that the billing account linked to your storage bucket differs from the one associated with your storage account. We highly recommend aligning them for billing consistency and clearer management."
msgstr ""

#: src/components/forms/MonthlyCostField.tsx
msgid "Please see how the cost of your resource is calculated."
msgstr "Consulte cómo se calcula el costo de su recurso."

#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Please select a VPC network to choose target servers from."
msgstr "Seleccione una red VPC para elegir los servidores de destino."

#: src/modules/billing/choose_method/AddPaymentMethodModal.tsx
msgid "Please select an item in the list"
msgstr "Seleccione un elemento de la lista"

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "Please upload a copy of the business registration document or ID card for verification (max {maxFileSizeInMB}MB)."
msgstr "Cargue una copia del documento de registro mercantil o de su documento de identidad para la verificación (máx. {maxFileSizeInMB} MB)."

#: src/modules/services/ServiceView.tsx
msgid "Pods and services hosted on this cluster will be stopped and any ephemeral storage will be discarded."
msgstr "Los pods y servicios alojados en este clúster se detendrán y se descartará cualquier almacenamiento efímero."

#: src/modules/billing/popup/popup.ts
msgid "Popup did not return from redirect"
msgstr ""

#: src/modules/billing/popup/popup.ts
msgid "Popup was closed before it could load"
msgstr ""

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Port"
msgstr "Puerto"

#: src/modules/network/validatePort.ts
msgid "Port must be between 1 and 65535"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Port range"
msgstr "Rango de puertos"

#: src/modules/services/ServiceCreate.tsx
msgid "PostgreSQL multi-node setup is a Primary/Standby setup with automatic fail-over."
msgstr ""

#. Resources attached to the billing account that have already been paid for
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Pre-paid resources"
msgstr ""

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Pre-payment"
msgstr "Prepago"

#: src/modules/compute/VmList.tsx
msgid "Price"
msgstr "Precio"

#: src/modules/compute/VmCreate.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Price list"
msgstr "Lista de precios"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Price per cycle"
msgstr ""

#: src/modules/pricing/PricingModal.tsx
msgid "Price per hour"
msgstr "Precio por hora"

#: src/modules/pricing/PricingModal.tsx
msgid "Price per month"
msgstr "Precio por mes"

#: src/modules/pricing/PricingModal.tsx
msgid "Prices may vary for the options below"
msgstr "Los precios pueden variar para las opciones siguientes"

#. The card that is selected for automatic charging (ie. main)
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/VmView.tsx
msgid "Primary"
msgstr "Principal"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Private"
msgstr "Privado"

#: src/modules/compute/BootFromIsoModal.tsx
msgid "Private images"
msgstr "Imágenes privadas"

#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
msgid "Private IP"
msgstr "IP privada"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceView.tsx
msgid "Private IPv4"
msgstr "IPv4 privada"

#: src/modules/services/Networking.tsx
msgid "Private network"
msgstr "Red privada"

#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
#: src/modules/billing/paypal/PaypalVaultAddForm.tsx
msgid "Problem with PayPal API."
msgstr ""

#: src/modules/user/ProfileView.tsx
#: src/modules/user/UserMenu.tsx
msgid "Profile"
msgstr "Perfil"

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Protocol"
msgstr "Protocolo"

#: src/modules/compute/VmCreate.tsx
msgid "Provide a valid cloud-config as JSON or YAML. This configuration will be passed as cloud-init user-data to the virtual machine. See cloud-init documentation about cloud-config for all the available options."
msgstr "Proporcione un cloud-config válido como JSON o YAML. Esta configuración se pasará a la máquina virtual como user-data de cloud-init. Consulte la documentación de cloud-init sobre cloud-config para ver todas las opciones disponibles."

#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Provider start of maintenance time window in which Provider may schedule automated cluster updates."
msgstr "Inicio de la ventana de mantenimiento del proveedor en la que el proveedor puede programar actualizaciones automáticas del clúster."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public"
msgstr "Público"

#: src/components/table/DetailsTableIpAddress.tsx
msgid "Public IP addresses are managed in the Network view."
msgstr "Las direcciones IP públicas se administran en la vista de Red."

#: src/components/table/DetailsTableIpAddress.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv4"
msgstr "IPv4 pública"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Public IPv6"
msgstr "IPv6 pública"

#: src/modules/compute/AddSshKeyModal.tsx
#: src/modules/user/ProfileView.tsx
msgid "Public key"
msgstr "Clave pública"

#: src/modules/compute/labels.tsx
msgid "Public key part of the SSH key pair for logging in to the VM. Must be in format <0>ssh-key-type base64encoded...key optional_comment</0>."
msgstr "Parte de clave pública del par de claves SSH para iniciar sesión en la máquina virtual. Debe tener el formato <0>ssh-key-type base64encoded...key optional_comment</0>."

#: src/modules/services/ConnectionDetails.tsx
msgid "Public network"
msgstr "Red pública"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Public URL"
msgstr "URL pública"

#. Short of: Quantity
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Qty."
msgstr "Cant."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "quarter"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Quarterly"
msgstr ""

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MetricsGrid.tsx
msgid "RAM"
msgstr "RAM"

#: src/modules/compute/VmToolbar.tsx
msgid "RDP link"
msgstr "Enlace RDP"

#: src/modules/services/ServiceView.tsx
msgid "Read more"
msgstr "Más información"

#. Only read permissions
#: src/modules/storage/account/CreateKeyModal.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Read-only"
msgstr ""

#: src/modules/services/ServiceView.tsx
msgid "Readiness"
msgstr "Preparación"

#: src/modules/metal/os/MetalOsSelect.tsx
msgid "Ready"
msgstr "Listo"

#. Table column: why the restriction level changed
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reason"
msgstr ""

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
msgid "Reboot"
msgstr "Reiniciar"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Recent"
msgstr "Recientes"

#: src/modules/billing/progressLabels.tsx
msgid "Redirecting to payment gateway"
msgstr "Redirigiendo a la pasarela de pago"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral code"
msgstr "Código de referido"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral link"
msgstr "Enlace de referido"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Referral program"
msgstr "Programa de referidos"

#: src/modules/billing/evc_hormuud/EvcHormuudPaymentForm.tsx
msgid "Refresh credit"
msgstr ""

#: src/modules/billing/account_validation/RefreshStatusButton.tsx
msgid "Refresh status"
msgstr "Actualizar estado"

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Registration number"
msgstr "Número de registro"

#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstall"
msgstr "Reinstalar"

#: src/modules/compute/ReinstallModal.tsx
msgid "Reinstalling \"{name}\" will destroy all data on the boot disk and set it to the initial clean OS state. All snapshots and backups are preserved."
msgstr "Al reinstalar \"{name}\" se destruirán todos los datos del disco de arranque y se restablecerá al estado inicial limpio del sistema operativo. Todas las instantáneas y copias de seguridad se conservarán."

#: src/components/sidebar/ListErrorBoundary.tsx
msgid "Reload"
msgstr "Recargar"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Reload data"
msgstr "Recargar datos"

#: src/root.tsx
msgid "Reload page"
msgstr ""

#: src/modules/billing/PaymentTopItem.tsx
msgid "Remaining credit <0/>"
msgstr "Crédito restante <0/>"

#: src/modules/network/firewall/FirewallView.tsx
msgid "Remove resource"
msgstr "Quitar recurso"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "Removing the public IPv4 address assignment from this resource will make the resource inaccessible from the public Internet. The IP address will remain reserved to your account. You can manage public IPv4 addresses from the Network menu on the left sidebar."
msgstr "Al eliminar la asignación de la dirección IPv4 pública de este recurso, el recurso dejará de ser accesible desde Internet pública. La dirección IP permanecerá reservada para su cuenta. Puede gestionar las direcciones IPv4 públicas desde el menú Red en la barra lateral izquierda."

#. placeholder {0}: item.grantee_username
#: src/modules/access/delegation/DelegationView.tsx
msgid "Removing user will revoke the rights from \"{0}\" to act as you."
msgstr "Al eliminar al usuario se revocarán los derechos de \"{0}\" para actuar en su nombre."

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Rename"
msgstr "Cambiar nombre"

#: src/modules/billing/invoice/DownloadPdf.tsx
msgid "Report"
msgstr "Informe"

#: src/modules/billing/invoice/invoiceLogic.tsx
msgid "Report {id}"
msgstr "Informe {id}"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Reports"
msgstr "Informes"

#. Metal commitment status
#: src/modules/metal/statusLabels.tsx
msgid "Requested"
msgstr ""

#: src/modules/metal/commitment/AddCommitmentModal.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Reservations"
msgstr ""

#. Disk status
#: src/modules/disks/DiskList.tsx
#: src/modules/disks/DiskStatusBadge.tsx
msgid "Reserved"
msgstr "Reservado"

#: src/modules/metal/commitment/CommitmentPriceBlock.tsx
msgid "Reserved and prepaid until <0/> ({daysRemaining} days remaining). Price shown as a monthly equivalent."
msgstr ""

#: src/modules/user/ProfileView.tsx
msgid "Reset password"
msgstr "Restablecer contraseña"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
msgid "Resize"
msgstr "Redimensionar"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Resize disk"
msgstr "Redimensionar disco"

#: src/modules/compute/VmResizeModal.tsx
msgid "Resizing is only possible when the virtual machine is stopped."
msgstr "El cambio de tamaño solo es posible cuando la máquina virtual está detenida."

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are deleted."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is forbidden. Existing resources are stopped."
msgstr ""

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Resource allocation is limited"
msgstr ""

#: src/modules/compute/VmCloneModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/disks/disk/DiskCloneModal.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Resource name"
msgstr "Nombre del recurso"

#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Resources"
msgstr "Recursos"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the same VPC network using private addresses of primary interfaces"
msgstr "recursos en la misma red VPC usando las direcciones privadas de las interfaces primarias"

#. VM is accessible by:
#: src/modules/compute/VmView.tsx
msgid "resources in the VPCs shared by VLAN sub-interfaces using their respective private address"
msgstr "recursos en las VPC compartidas por subinterfaces de VLAN usando sus respectivas direcciones privadas"

#: src/modules/billing/omise/parseOmisePersistentData.ts
msgid "Response seems to be taking longer than expected. Wait a bit and refresh the page to see changes reflected. The result might be either successful or unsuccessful."
msgstr ""

#: src/modules/billing/payment/paymentUtils.ts
msgid "Response seems to be taking more time than expected. Wait a bit and refresh the page to see payment status changes reflected. If it doesn't happen in a reasonable time, please contact support."
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/Backups.tsx
msgid "Restore"
msgstr "Restaurar"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
#: src/modules/services/Backups.tsx
msgid "Restore from backup"
msgstr "Restaurar desde una copia de seguridad"

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restore from snapshot"
msgstr "Restaurar desde una instantánea"

#: src/modules/services/Backups.tsx
msgid "Restoring from a backup will overwrite the service's state with the selected backup's state."
msgstr "Restaurar desde una copia de seguridad sobrescribirá el estado del servicio con el estado de la copia de seguridad seleccionada."

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this backup will overwrite the current state."
msgstr ""

#: src/modules/compute/VmRestoreFromReplicaModal.tsx
msgid "Restoring this snapshot will overwrite the current state."
msgstr ""

#: src/modules/access/scopeLabel.tsx
msgid "Restricted"
msgstr "Restringido"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Restriction level changed"
msgstr ""

#: src/modules/compute/VmView.tsx
msgid "Retention"
msgstr ""

#. Button action
#: src/components/sidebar/ErrorItem.tsx
#: src/modules/notifications/toast.tsx
msgid "Retry"
msgstr "Reintentar"

#: src/styles/readyidc/theme.tsx
msgid "Revolutionize your cloud with AMD EPYC"
msgstr ""

#. Registre National des Entreprises (RNE) company registration document
#: src/styles/dataxion/theme.tsx
msgid "RNE document"
msgstr "Documento RNE"

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that allows it."
msgstr "Las reglas de todos los cortafuegos vinculados se combinan; se permite una conexión si existe al menos una regla que la permita."

#: src/modules/metal/MetalCreate.tsx
msgid "Run your applications on Bare Metal Servers for full control, security, and raw performance. Provision a dedicated server optimized for your most demanding use cases."
msgstr "Ejecute sus aplicaciones en servidores físicos para obtener control total, seguridad y rendimiento puro. Aprovisione un servidor dedicado optimizado para sus casos de uso más exigentes."

#. Virtual machine status
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/monitor/MetricChart.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Running"
msgstr "En ejecución"

#: src/modules/storage/StorageCreate.tsx
msgid "S3-compatible object storage allows you to scale your storage resources up and down without any upfront payments. Create a new storage account, create some buckets and start storing your data in a scalable way - Pay-as-you-grow."
msgstr ""

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/LowBalanceNotificationsModal.tsx
#: src/modules/currency/CurrencyModal.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Save"
msgstr "Guardar"

#: src/modules/billing/progressLabels.tsx
msgid "Saving payment information"
msgstr "Guardando la información de pago"

#: src/modules/billing/QrCodeDisplay.tsx
msgid "Scan the QR code to pay"
msgstr "Escanee el código QR para pagar"

#: src/modules/access/AccessCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "Scope"
msgstr "Ámbito"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Search"
msgstr "Buscar"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Secret access key"
msgstr "Clave secreta de acceso"

#: src/modules/billing/forms/FileWithSourceInput.tsx
msgid "Select a file"
msgstr "Seleccione un archivo"

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Select a payment method"
msgstr "Seleccione un método de pago"

#: src/components/forms/WSelect.tsx
msgid "Select an option"
msgstr "Seleccione una opción"

#. placeholder {0}: siteCurrencyInfo.title
#: src/modules/currency/CurrencyModal.tsx
msgid "Select your display currency to view prices in your preferred currency. Displayed amounts and exchange rates are indicative and for informational purposes only. All transactions are processed in the underlying currency ({0}), and final charges may vary based on your payment provider's rates."
msgstr "Seleccione su moneda de visualización para ver los precios en su moneda preferida. Los importes y tipos de cambio que se muestran son orientativos y solo con fines informativos. Todas las transacciones se procesan en la moneda subyacente ({0}) y los cargos finales pueden variar según las tarifas de su proveedor de pagos."

#: src/modules/currency/CurrencyModal.tsx
msgid "Select your preferred currency"
msgstr "Seleccione su moneda preferida"

#: src/modules/compute/WVnc.tsx
msgid "Send Ctrl+Alt+Del"
msgstr "Enviar Ctrl+Alt+Supr"

#: src/modules/login/Login.tsx
msgid "Send email"
msgstr "Enviar correo"

#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Server"
msgstr "Servidor"

#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/pricing/PricingModal.tsx
msgid "Server class"
msgstr "Clase de servidor"

#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
msgid "Service"
msgstr "Servicio"

#: src/modules/services/ServiceCreate.tsx
msgid "Service name"
msgstr "Nombre del servicio"

#: src/modules/api/resourceTypes.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/services/ServicesList.tsx
msgid "Services"
msgstr "Servicios"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Set by an administrator"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
msgid "Set default"
msgstr "Establecer como predeterminado"

#. 'private' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'private'"
msgstr "Establecer la ACL del objeto en 'private'"

#. 'public-read' is a literal string
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Set object's ACL to 'public-read'"
msgstr "Establecer la ACL del objeto en 'public-read'"

#. Button action
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "Share access"
msgstr "Compartir acceso"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on Facebook"
msgstr ""

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on LinkedIn"
msgstr ""

#. X is the social network
#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Share on X"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Share temporarily"
msgstr "Compartir temporalmente"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sharing duration"
msgstr "Duración para compartir"

#. Button action
#: src/components/SecretKey.tsx
#: src/modules/services/TextSecret.tsx
msgid "Show"
msgstr "Mostrar"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Show details"
msgstr "Mostrar detalles"

#. An item is any kind of resource being managed (e.g. VM, disk, bucket, etc).
#: src/modules/dashboard/RecentlyModified.tsx
msgid "Showing {limit} latest items"
msgstr "Mostrando los {limit} elementos más recientes"

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Showing list prices. Discount applied in the cost summary."
msgstr "Mostrando precios de lista. El descuento se aplica en el resumen de costos."

#: src/modules/login/auth0/Auth0Login.tsx
#: src/modules/login/Login.tsx
msgid "Sign up"
msgstr "Registrarse"

#: src/modules/login/Login.tsx
msgid "Sign up with Google"
msgstr "Registrarse con Google"

#: src/modules/compute/DiskAddOrResizeModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmResizeModal.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/DiskCreate.tsx
#: src/modules/disks/DiskList.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/kubernetes/NodeResizeModal.tsx
#: src/modules/services/ServiceCreate.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageList.tsx
msgid "Size"
msgstr "Tamaño"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Size (GB)"
msgstr "Tamaño (GB)"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
msgid "Snapshots"
msgstr "Instantáneas"

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "Social share"
msgstr "Compartir en redes sociales"

#: src/modules/metal/spec/SpecRadio.tsx
msgid "Sold out"
msgstr "Agotado"

#. Label for dropdown menu that selects by what files are sorted. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort"
msgstr "Ordenar"

#: src/components/sidebar/SortMenu.tsx
msgid "Sort by"
msgstr "Ordenar por"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by date"
msgstr "Ordenar por fecha"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by name"
msgstr "Ordenar por nombre"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Sort by size"
msgstr "Ordenar por tamaño"

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
msgid "Source port"
msgstr "Puerto de origen"

#: src/modules/network/loadbalancer/validatePorts.ts
msgid "Source port must be unique"
msgstr ""

#: src/modules/compute/VmView.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
msgid "Sources"
msgstr "Orígenes"

#: src/modules/compute/AddSshKeyModal.tsx
msgid "SSH key does not match required pattern"
msgstr "La clave SSH no coincide con el patrón requerido"

#: src/modules/compute/VmCreate.tsx
#: src/modules/user/ProfileView.tsx
msgid "SSH keys"
msgstr "Claves SSH"

#: src/modules/compute/VmCreate.tsx
msgid "SSH keys can be managed under your <0>user profile</0>."
msgstr "Las claves SSH se pueden gestionar en su <0>perfil de usuario</0>."

#: src/modules/compute/VmToolbar.tsx
msgid "SSH link"
msgstr "Enlace SSH"

#: src/modules/compute/VmRootUserWarning.tsx
msgid "SSH might not be available for root user due to operating system initial setup. Please use virtual console to access the system and make the SSH server config changes according to your needs."
msgstr "Es posible que SSH no esté disponible para el usuario root debido a la configuración inicial del sistema operativo. Utilice la consola virtual para acceder al sistema y realizar los cambios de configuración del servidor SSH según sus necesidades."

#. Button action
#: src/modules/compute/BootFromIsoModal.tsx
#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/support/WChatProvider.tsx
#: src/modules/user/ActAsModal.tsx
msgid "Start"
msgstr "Iniciar"

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "Start date"
msgstr ""

#: src/modules/billing/account_validation/digio/StartDigioValidationButton.tsx
msgid "Start here"
msgstr "Comenzar aquí"

#: src/modules/network/NetworkCreate.tsx
msgid "Start managing your networks by creating a new network resource."
msgstr "Comience a administrar sus redes creando un nuevo recurso de red."

#: src/modules/network/firewall/firewallLabels.tsx
msgid "Start port"
msgstr ""

#: src/modules/network/firewall/validatePorts.ts
msgid "Start port must be unique"
msgstr ""

#: src/modules/dashboard/StartSomethingNew.tsx
msgid "Start something new"
msgstr "Comience algo nuevo"

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Start time"
msgstr "Hora de inicio"

#: src/modules/billing/progressLabels.tsx
msgid "Starting payment"
msgstr "Iniciando el pago"

#. Part of address
#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "State"
msgstr ""

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/user/ProfileView.tsx
msgid "Status"
msgstr "Estado"

#. Short of: billing account status history
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Status history"
msgstr ""

#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/VmToolbar.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/services/ServiceView.tsx
msgid "Stop"
msgstr "Detener"

#. Virtual machine status
#: src/modules/compute/ModalHeaderBlock.tsx
#: src/modules/compute/statusLabels.tsx
#: src/modules/services/ServicesList.tsx
msgid "Stopped"
msgstr "Detenida"

#. Virtual machine status
#: src/modules/compute/statusLabels.tsx
msgid "Stopping"
msgstr "Deteniéndose"

#: src/modules/api/resourceTypes.tsx
#: src/modules/main/sidebar/Sidebar.sections.tsx
#: src/modules/storage/StorageList.tsx
msgid "Storage"
msgstr "Almacenamiento"

#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage access keys"
msgstr "Claves de acceso al almacenamiento"

#: src/modules/api/resourceTypes.tsx
#: src/modules/storage/bucket/BucketView.tsx
msgid "Storage account"
msgstr ""

#: src/modules/api/resourceTypes.tsx
msgid "Storage bucket"
msgstr "Bucket de almacenamiento"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "Storage bucket name"
msgstr "Nombre del bucket de almacenamiento"

#. List of S3 storage buckets
#: src/modules/storage/account/StorageAccountView.tsx
msgid "Storage buckets"
msgstr ""

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Street address"
msgstr "Dirección (calle y número)"

#: src/modules/services/ConnectionDetails.tsx
msgid "String"
msgstr "Cadena"

#: src/modules/network/NetworkCreate.tsx
msgid "Subnet range (CIDR)"
msgstr ""

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal"
msgstr "Subtotal"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Subtotal before discounts"
msgstr ""

#. Button label. Short of: Contact customer support
#: src/modules/main/TopNav.tsx
msgid "Support"
msgstr "Soporte"

#. Billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Suspended"
msgstr "Suspendida"

#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Suspension reason changed"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to Grid view"
msgstr "Cambiar a vista de cuadrícula"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Switch to List view"
msgstr "Cambiar a vista de lista"

#: src/modules/services/kubernetes/KubernetesReadynessBadge.tsx
msgid "system"
msgstr "sistema"

#. What caused the billing account status change
#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "System"
msgstr ""

#: src/modules/compute/labels.tsx
msgid "Take a snapshot to create an instant image of your virtual machine's current state. You can later use the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot with modified size parameters."
msgstr "Cree una instantánea para generar una imagen del estado actual de su máquina virtual. Después podrá usar la instantánea para restaurar el estado de su máquina virtual o crear una nueva máquina virtual a partir de ella con parámetros de tamaño modificados."

#: src/modules/compute/VmView.tsx
msgid "Take snapshot"
msgstr "Crear instantánea"

#: src/modules/dashboard/RecentlyModified.tsx
msgid "Take some action and you'll never see this cactus again."
msgstr "Realice alguna acción y no volverá a ver este cactus nunca más."

#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/ForwardingRulesList.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Target port"
msgstr "Puerto de destino"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/NetworkCreate.tsx
msgid "Target servers"
msgstr "Servidores de destino"

#: src/modules/compute/VmToolbar.tsx
#: src/modules/compute/WVnc.tsx
msgid "Terminal"
msgstr "Consola"

#. Billing account restriction level
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Terminated"
msgstr ""

#: src/modules/login/ConsentForm.tsx
msgid "Terms of Service"
msgstr "Términos del servicio"

#: src/modules/pricing/PricingModal.tsx
msgid "The actual cost of your resource is calculated based on the below prices and your actual hourly usage. All prices are per one unit of resource (1 vCPU or 1 GiB). Prices do not contain taxes."
msgstr "El costo real de su recurso se calcula en función de los precios de abajo y de su uso horario real. Todos los precios son por una unidad de recurso (1 vCPU o 1 GiB). Los precios no incluyen impuestos."

#: src/modules/billing/forms/BillingSelect.tsx
msgid "The billing account has been closed and is no longer available."
msgstr "La cuenta de facturación se ha cerrado y ya no está disponible."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "The campaign code is activated only after a successful top up."
msgstr "El código de campaña se activa solo después de una recarga de saldo exitosa."

#: src/modules/user/ActAsModal.tsx
msgid "The entire user interface will switch and act as you were that user. Once you are finished you can stop the session by clicking “Back to your account” button on the header bar and the user interface will switch back to your account."
msgstr "Toda la interfaz cambiará y actuará como si fuera ese usuario. Cuando termine, puede finalizar la sesión haciendo clic en el botón “Volver a su cuenta” en la barra superior y la interfaz volverá a su cuenta."

#: src/modules/billing/ConversionMessage.tsx
msgid "The final exchange rate and charge amount will be determined at the moment of actual payment."
msgstr "El tipo de cambio final y el importe del cargo se determinarán en el momento del pago."

#: src/modules/billing/promotionNotices.tsx
msgid "The first top up will unlock your complimentary free credit of <0><1/></0>."
msgstr "La primera recarga desbloqueará su crédito gratuito de cortesía de <0><1/></0>."

#: src/modules/billing/omise/OmiseCardAddForm.tsx
msgid "The format is MM/YY"
msgstr ""

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "The link expires on:"
msgstr "El enlace caduca el:"

#: src/modules/storage/account/CreateBucketModal.tsx
msgid "The name can only contain lowercase alphanumeric characters and dashes, it must start with a lowercase letter or number, the allowed length is 3–63."
msgstr "El nombre solo puede contener caracteres alfanuméricos en minúsculas y guiones; debe comenzar con una letra minúscula o un número; la longitud permitida es de 3 a 63."

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The password can be changed for any existing user account."
msgstr "La contraseña se puede cambiar para cualquier cuenta de usuario existente."

#: src/modules/billing/sslcommerz/SslcommerzPaymentForm.tsx
msgid "The phone/mobile number to contact if any issue arises"
msgstr "Número de teléfono/celular de contacto en caso de que surja algún problema"

#: src/components/forms/MonthlyCostField.tsx
msgid "The price is approximate, the cost of your resource will be calculated based on your actual hourly usage."
msgstr "El precio es aproximado; el costo de su recurso se calculará según su uso real por hora."

#: src/modules/compute/PasswordFields.tsx
msgid "The re-typed password, to ensure that it has been entered correctly."
msgstr "La contraseña escrita de nuevo para asegurarse de que se haya introducido correctamente."

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account does not have enough credit to purchase this reservation."
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "The selected billing account is limited and can not create reservations."
msgstr ""

#: src/modules/network/NetworkCreate.tsx
msgid "The subnet must fall within one the following IP blocks:"
msgstr ""

#: src/modules/compute/ChangePasswordModal.tsx
msgid "The user account for which password will be set."
msgstr "La cuenta de usuario para la que se establecerá la contraseña."

#: src/modules/login/Login.tsx
msgid "There was an error verifying your email address."
msgstr "Se produjo un error al verificar su dirección de correo electrónico."

#: src/components/sidebar/ErrorItem.tsx
msgid "There was an error while creating your resource."
msgstr "Se produjo un error al crear su recurso."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "These credentials are only for the initial login. It is recommended to change these immediately."
msgstr "Estas credenciales son solo para el inicio de sesión inicial. Se recomienda cambiarlas de inmediato."

#. This resource was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This {resourceTypeName} is gone"
msgstr ""

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "This bare metal server is still being set up."
msgstr "Este servidor físico aún se está configurando."

#: src/modules/billing/LimitedBillingAccountNotice.tsx
msgid "This billing account has limited capabilities when creating resources."
msgstr "Esta cuenta de facturación tiene capacidades limitadas al crear recursos."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "This billing account is limited"
msgstr "Esta cuenta de facturación está limitada"

#: src/modules/compute/VmCreate.tsx
msgid "This distribution adds a <0/> cost per hour for licensing (<1/> per month)."
msgstr "Esta distribución añade un costo de <0/> por hora por licencia (<1/> al mes)."

#: src/components/forms/requiredMessage.tsx
msgid "This field is required"
msgstr ""

#: src/modules/storage/account/CreateKeyModal.tsx
msgid "This key has access to all buckets under this storage account. To restrict access to specific buckets, create a separate storage account."
msgstr ""

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "This page is gone"
msgstr ""

#: src/modules/services/Access.tsx
#: src/modules/services/Networking.tsx
msgid "This service is accessible only by resources in the same VPC network using these private addresses."
msgstr "Este servicio solo es accesible por recursos en la misma red VPC usando estas direcciones privadas."

#: src/modules/compute/VmView.tsx
msgid "This virtual machine is accessible by:"
msgstr "Esta máquina virtual es accesible por:"

#: src/modules/network/firewall/FirewallDeleteModal.tsx
msgid "This will delete the firewall and its associated rules, and they will no longer apply to any assigned resources."
msgstr "Esto eliminará el firewall y sus reglas asociadas, y ya no se aplicarán a ningún recurso asignado."

#: src/modules/compute/VmToolbar.tsx
msgid "This will forcefully shut down your resource \"{name}\". For stopped resources you will only be charged for the storage."
msgstr "Esto apagará a la fuerza su recurso \"{name}\". Para los recursos detenidos solo se le cobrará el almacenamiento."

#: src/modules/services/ServiceView.tsx
msgid "This will hibernate cluster \"{display_name}\"."
msgstr "Esto hibernará el clúster \"{display_name}\"."

#: src/modules/billing/billingAccount/BillingCreate.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "This will only be used within the system so it's easy for you to recognize the account if you have several."
msgstr "Solo se utilizará dentro del sistema para que le resulte fácil reconocer la cuenta si tiene varias."

#: src/modules/compute/VmToolbar.tsx
msgid "This will reboot your resource \"{name}\"."
msgstr "Esto reiniciará su recurso \"{name}\"."

#: src/modules/services/IpWhitelist.tsx
msgid "This will remove the address or range from the allowlist.<0/>Note that an empty allowlist will permit connections from any address."
msgstr "Esto eliminará la dirección o el rango de la lista de direcciones IP permitidas.<0/>Tenga en cuenta que una lista vacía permitirá conexiones desde cualquier dirección."

#: src/modules/services/ServiceView.tsx
msgid "This will shut down your resource \"{display_name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Esto apagará su recurso «{display_name}». Si el apagado ordenado no finaliza en 120 segundos, se realizará una detención forzosa. En los recursos detenidos solo se le cobrará por el almacenamiento."

#: src/modules/compute/VmToolbar.tsx
msgid "This will shut down your resource \"{name}\". If graceful shutdown does not finish in 120 seconds, then a forceful stop will be carried out. For stopped resources you will only be charged for the storage."
msgstr "Esto apagará su recurso \"{name}\". Si el apagado ordenado no finaliza en 120 segundos, se realizará una detención forzosa. Para los recursos detenidos solo se le cobrará el almacenamiento."

#: src/modules/network/loadbalancer/LoadBalancerDeleteModal.tsx
msgid "This will stop forwarding traffic to the targets and remove the load balancer."
msgstr "Esto detendrá el reenvío de tráfico a los destinos y eliminará el balanceador de carga."

#. Amount below which a low balance notification will be sent
#: src/modules/billing/LowBalanceNotificationsModal.tsx
msgid "Threshold"
msgstr "Umbral"

#. This page was not found
#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. Here are some ideas where to go next:"
msgstr ""

#: src/modules/error/ErrorFallback.tsx
msgid "Time to move on. This item is deleted or you do not have access."
msgstr ""

#: src/modules/billing/razorpay/RazorpayPaymentForm.tsx
msgid "Timed out waiting for a response from Razorpay"
msgstr ""

#: src/modules/services/kubernetes/Maintenance.tsx
#: src/modules/services/kubernetes/MaintenanceEditModal.tsx
msgid "Timezone"
msgstr "Zona horaria"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "To activate a billing account, please add a credit card as a payment method or contact support to enable invoice payments."
msgstr "Para activar una cuenta de facturación, añada una tarjeta de crédito como método de pago o contacte con soporte para habilitar los pagos por factura."

#: src/modules/services/IpWhitelist.tsx
msgid "To restrict connections to the service you have to add at least one inbound IP to the allowlist (All other public and private connections will be denied). You can specify a single IPv4 address or a block of addresses using CIDR notation (e.g. 1.1.1.0/24)"
msgstr "Para restringir las conexiones al servicio, debe añadir al menos una IP de entrada a la lista de direcciones IP permitidas (todas las demás conexiones públicas y privadas serán denegadas). Puede especificar una única dirección IPv4 o un bloque de direcciones usando la notación CIDR (p. ej., 1.1.1.0/24)"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/WelcomeModal.tsx
msgid "To start using the platform you need to first setup billing account. You are welcome to click around to familiarize yourself with the system and come back to billing account creation at any time you are ready to start building your first resources."
msgstr "Para empezar a utilizar la plataforma, primero debe configurar una cuenta de facturación. Puede explorar la interfaz para familiarizarse con el sistema y volver a la creación de la cuenta de facturación cuando esté listo para empezar a crear sus primeros recursos."

#: src/modules/login/ConsentForm.tsx
msgid "To use our services, you need to agree to the Terms of Service."
msgstr "Para usar nuestros servicios, debe aceptar los Términos del servicio."

#: src/modules/access/token/TokenView.tsx
msgid "Token"
msgstr "Token"

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up"
msgstr "Recargar saldo"

#. How much to top up | POS: Noun
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Top up amount"
msgstr "Importe de la recarga"

#: src/modules/billing/promotionNotices.tsx
msgid "Top up at least <0><1/></0> to obtain <2><3/></2> of referral code bonus."
msgstr "Recargue al menos <0><1/></0> para obtener una bonificación por código de referido de <2><3/></2>."

#: src/modules/billing/ActionButtons.tsx
msgid "Top up now"
msgstr "Recargar saldo ahora"

#. Top up your billing account
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Top up your account"
msgstr "Recargar su cuenta"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Top-up"
msgstr ""

#. Invoices for billing account top-ups
#: src/components/themeTrans.tsx
msgid "Top-up invoices"
msgstr "Facturas de recarga de saldo"

#: src/styles/dataxion/theme.tsx
msgid "Top-up orders"
msgstr "Pedidos de recarga de saldo"

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-up threshold reached"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> are below the threshold of <1/>"
msgstr ""

#: src/modules/billing/statusHistory/StatusHistory.tsx
msgid "Top-ups of <0/> reached the threshold of <1/>"
msgstr ""

#. Total amount of the invoice
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/invoice/InvoiceView.tsx
#: src/modules/billing/InvoicePaymentInfo.tsx
msgid "Total"
msgstr "Total"

#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Total charge"
msgstr "Cargo total"

#. Short of: Total excluding
#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Total excl. {vatSymbol}"
msgstr "Total sin {vatSymbol}"

#: src/components/themeTrans.tsx
msgid "Total of all unpaid invoices. Including {vatSymbol}."
msgstr "Total de todas las facturas no pagadas. Incluye {vatSymbol}."

#: src/styles/dataxion/theme.tsx
msgid "Total of all unpaid orders. Including VAT."
msgstr "Total de todos los pedidos impagos. Incluye IVA."

#: src/modules/billing/CurrencyPaymentFees.tsx
#: src/modules/billing/CurrencyPaymentFees.tsx
msgid "Transaction fee"
msgstr "Comisión por transacción"

#. Table column: what caused the change | POS: Noun
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Trigger"
msgstr ""

#: src/modules/access/AccessCreate.tsx
#: src/modules/access/AccessList.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/compute/ReinstallModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalCreate.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/AssignedToList.tsx
#: src/modules/network/firewall/EditRuleModal.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/firewall/RulesList.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/loadbalancer/TargetServersList.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/bucket/BucketView.tsx
#: src/modules/storage/StorageCreate.tsx
msgid "Type"
msgstr "Tipo"

#: src/modules/compute/labels.tsx
msgid "UEFI variables (NVRAM) will not persist across reboots."
msgstr ""

#: src/modules/access/AccessList.tsx
msgid "UI"
msgstr "IU"

#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/ipAddress/UnAssignButton.tsx
msgid "Unassign"
msgstr "Desasignar"

#. State of IP address
#: src/modules/dashboard/RecentlyModified.tsx
#: src/modules/network/CreateAndAssignIpField.tsx
#: src/modules/network/ipAddress/IpAddressView.tsx
#: src/modules/network/NetworkList.tsx
#: src/modules/network/UnassignedItem.tsx
msgid "Unassigned"
msgstr "Sin asignar"

#: src/modules/billing/invoice/InvoiceView.tsx
msgid "Unit"
msgstr "Unidad"

#. Label for an unknown item in a select control
#: src/components/EnumBadge.tsx
#: src/modules/billing/BillingAccountLink.tsx
#: src/modules/network/NetworkList.tsx
msgid "Unknown"
msgstr "Desconocido"

#: src/modules/login/auth0/Auth0Exception.ts
msgid "Unknown Auth0 error"
msgstr ""

#: src/modules/access/scopeLabel.tsx
msgid "Unknown billing account"
msgstr "Cuenta de facturación desconocida"

#: src/modules/billing/payment/paymentUtils.ts
msgid "Unknown payment error{codeSuffix}"
msgstr ""

#: src/modules/disks/AttachedToSelect.tsx
#: src/modules/network/AssignToSelect.tsx
msgid "Unknown resource"
msgstr "Recurso desconocido"

#: src/modules/network/loadbalancer/LoadBalancerView.tsx
msgid "Unlink target"
msgstr "Desvincular destino"

#: src/modules/billing/BillingList.tsx
#: src/modules/billing/ReportStatus.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Unpaid"
msgstr "Impagado"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Unpaid amount"
msgstr "Importe impago"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/payment/PaymentModal.tsx
msgid "Unverified"
msgstr "No verificado"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update"
msgstr "Actualizar"

#: src/modules/compute/UpdateSshKeyModal.tsx
msgid "Update SSH key"
msgstr "Actualizar clave SSH"

#. Button action to upload a file. | POS: Verb
#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Upload"
msgstr "Subir"

#: src/styles/dataxion/theme.tsx
msgid "Upload a copy of only the RNE document for verification"
msgstr "Cargue una copia únicamente del documento RNE para su verificación"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploading files"
msgstr "Subiendo archivos"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Uploads are still in progress. If you leave this page, progress will no longer be shown and uploads may be interrupted. Leave anyway?"
msgstr ""

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Usage"
msgstr "Uso"

#. What caused the billing account status change
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "Usage charge"
msgstr ""

#: src/modules/compute/VmCreate.tsx
msgid "Use the ISO boot option after the virtual machine has been created to install an operating system yourself."
msgstr "Use la opción de arranque desde ISO después de crear la máquina virtual para instalar usted mismo un sistema operativo."

#. Who changed the billing account status
#: src/modules/billing/statusHistory/statusHistoryLabels.tsx
msgid "User"
msgstr ""

#: src/modules/dashboard/UserAccess.tsx
msgid "User access"
msgstr "Acceso de usuario"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
msgid "User must accept access invitation from their profile view"
msgstr "El usuario debe aceptar la invitación de acceso desde su vista de perfil"

#. Link to regular user interface
#: src/modules/user/UserMenu.tsx
msgid "User view"
msgstr "Vista de usuario"

#: src/modules/access/delegation/AddImpersonationForm.tsx
msgid "User's email"
msgstr "Correo electrónico del usuario"

#: src/modules/compute/ChangePasswordModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/compute/VmView.tsx
msgid "Username"
msgstr "Nombre de usuario"

#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users I can access"
msgstr "Usuarios a los que puedo acceder"

#: src/modules/access/delegation/DelegationView.tsx
#: src/modules/dashboard/UserAccess.tsx
#: src/modules/user/ProfileView.tsx
msgid "Users who can access my account"
msgstr "Usuarios que pueden acceder a mi cuenta"

#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/compute/VmView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/disks/disk/DiskView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/metal/MetalLeaseDetailView.tsx
#: src/modules/network/firewall/FirewallView.tsx
#: src/modules/network/loadbalancer/LoadBalancerView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/services/Backups.tsx
#: src/modules/services/ServiceView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
msgid "UUID"
msgstr "UUID"

#: src/modules/billing/payment_forms/labels.tsx
msgid "Valid thru"
msgstr "Válida hasta"

#: src/modules/billing/BillingAccountInfo.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "Validation pending"
msgstr "Validación pendiente"

#: src/modules/compute/ParamsTextField.tsx
msgid "Value does not match required pattern"
msgstr ""

#: src/components/VatText.tsx
msgid "VAT"
msgstr "IVA"

#: src/components/VatText.tsx
msgid "VAT number"
msgstr "Número de IVA"

#: src/modules/billing/LimitedBillingAccountNotice.tsx
#: src/modules/compute/MachineSizeInfo.tsx
#: src/modules/services/kubernetes/Infrastructure.tsx
#: src/modules/services/kubernetes/NodePoolsList.tsx
msgid "vCPU"
msgstr "vCPU"

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "Verified"
msgstr "Verificado"

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Verified payment method is missing"
msgstr "Falta un método de pago verificado"

#: src/modules/billing/progressLabels.tsx
msgid "Verifying payment method"
msgstr "Verificando el método de pago"

#: src/modules/compute/os/OsVersionSelect.tsx
#: src/modules/metal/os/MetalOsSelect.tsx
#: src/modules/services/os/OsVersionSelect.tsx
msgid "Version"
msgstr "Versión"

#. Button action
#: src/components/ResourceLink.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
#: src/modules/network/vpc/VpcView.tsx
#: src/modules/notifications/toast.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/storage/account/StorageAccountView.tsx
#: src/modules/user/ProfileView.tsx
msgid "View"
msgstr "Ver"

#: src/components/table/WTable.tsx
msgid "View all records"
msgstr "Ver todos los registros"

#: src/modules/compute/VmView.tsx
msgid "View config commands"
msgstr "Ver comandos de configuración"

#: src/modules/billing/BillingAccountNotices.tsx
#: src/modules/dashboard/BillingAccounts.tsx
msgid "View details"
msgstr "Ver detalles"

#: src/components/table/WTable.tsx
msgid "View last {limit} records"
msgstr "Ver los últimos {limit} registros"

#: src/modules/user/InvitationNotice.tsx
msgid "View more"
msgstr "Ver más"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Virtual host style URL"
msgstr "URL de estilo host virtual"

#: src/modules/api/resourceTypes.tsx
msgid "Virtual machine"
msgstr "Máquina virtual"

#: src/modules/compute/SubInterfaceModal.tsx
msgid "VLAN"
msgstr "VLAN"

#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmView.tsx
msgid "VLAN ID"
msgstr "ID de VLAN"

#: src/modules/services/Networking.tsx
msgid "VPC IP range"
msgstr "Rango de IP de la VPC"

#: src/modules/compute/VmView.tsx
msgid "VPC name"
msgstr "Nombre de la VPC"

#: src/modules/api/resourceTypes.tsx
#: src/modules/compute/AddSubInterfaceModal.tsx
#: src/modules/compute/VmCreate.tsx
#: src/modules/network/NetworkCreate.tsx
#: src/modules/network/VpcRow.tsx
#: src/modules/services/ConnectionDetails.tsx
#: src/modules/services/Networking.tsx
#: src/modules/services/ServiceCreate.tsx
msgid "VPC network"
msgstr "Red VPC"

#: src/modules/network/NetworkCreate.tsx
msgid "VPC network is available at no additional cost."
msgstr "La red VPC está disponible sin costo adicional."

#: src/modules/billing/BillingAccountInfo.tsx
msgid "Wait for verification or add card"
msgstr "Espere la verificación o añada una tarjeta"

#: src/modules/billing/progressLabels.tsx
msgid "Waiting for payment confirmation"
msgstr "Esperando la confirmación del pago"

#: src/modules/billing/popup/popup.ts
msgid "Waiting for popup to return from redirect timed out"
msgstr ""

#: src/modules/services/kubernetes/KubernetesStatusBadge.tsx
#: src/modules/services/ServicesList.tsx
msgid "Waking up"
msgstr "Despertando"

#: src/modules/access/AdminUserWarning.tsx
#: src/modules/compute/VmCreate.tsx
msgid "Warning"
msgstr "Advertencia"

#: src/modules/compute/DiskAddOrResizeModal.tsx
msgid "Warning: It is recommended to stop the virtual machine before resizing the boot disk."
msgstr "Advertencia: Se recomienda detener la máquina virtual antes de redimensionar el disco de arranque."

#: src/modules/billing/choose_method/invoiceMethodLogic.tsx
msgid "We recommend adding a credit card while your request is being processed to activate services right away."
msgstr "Recomendamos agregar una tarjeta de crédito mientras se procesa su solicitud para activar los servicios de inmediato."

#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "We recommend automated top up as it minimizes the risk of running out of funds and thus affecting your server resources."
msgstr "Recomendamos la recarga automática, ya que minimiza el riesgo de quedarse sin fondos y, por lo tanto, de afectar sus recursos de servidor."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "We've assembled some links to get you started. Develop, test code, and deploy your applications in no time, from prototyping to large-scale development."
msgstr "Hemos reunido algunos enlaces para que pueda comenzar. Desarrolle, pruebe su código y despliegue sus aplicaciones en poco tiempo, desde el prototipo hasta el desarrollo a gran escala."

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "We've reached the capacity of our file browser. In order to maintain the stability of our user interface, we've terminated the loading of your bucket contents. Please utilize external tools at your disposal to manage the content within your bucket"
msgstr "Hemos alcanzado la capacidad de nuestro explorador de archivos. Para mantener la estabilidad de nuestra interfaz de usuario, hemos detenido la carga del contenido de su bucket de almacenamiento. Utilice las herramientas externas a su disposición para gestionar el contenido de su bucket."

#: src/modules/dashboard/WelcomeBlock.tsx
msgid "Welcome"
msgstr "Bienvenido"

#: src/modules/dashboard/WelcomeModal.tsx
msgid "Welcome!<0/>We're glad you're here."
msgstr "¡Bienvenido!<0/>Nos alegra que esté aquí."

#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "What would you like to do?"
msgstr "¿Qué le gustaría hacer?"

#: src/modules/billing/AutomatedTopUpModal.tsx
#: src/modules/billing/billingAccount/BillingAccountView.tsx
msgid "When balance goes below"
msgstr "Cuando el saldo baje de"

#: src/modules/network/ipAddress/IpAddressView.tsx
msgid "When reserved but not assigned to a resource IPv4 address will be charged for <0/> / month."
msgstr "Cuando esté reservada pero no asignada a un recurso, la dirección IPv4 se cobrará a <0/> al mes."

#: src/modules/network/CreateAndAssignIpField.tsx
msgid "When selected, a public floating IPv4 address will be created and assigned automatically to your resource. If you do not want to have public access to your resource you can unselect the option here or remove the IP address later."
msgstr "Cuando esté seleccionada, se creará y asignará automáticamente una dirección IPv4 pública flotante a su recurso. Si no desea que su recurso tenga acceso público, puede desmarcar la opción aquí o eliminar la dirección IP más tarde."

#: src/modules/compute/VmView.tsx
msgid "When you enable the backup service, an automatic disk-level backup will be created from the boot disk (excluding additional disks). A backup will be created once a week and will be listed here. You can later use the backup images to restore your virtual machine or create a new virtual machine with modified size parameters from the backup."
msgstr "Al habilitar el servicio de copias de seguridad, se creará una copia de seguridad automática a nivel de disco a partir del disco de arranque (excluyendo los discos adicionales). Se creará una copia de seguridad una vez por semana y aparecerá aquí. Posteriormente podrá usar las imágenes de copia de seguridad para restaurar su máquina virtual o crear una nueva máquina virtual con parámetros de tamaño modificados a partir de la copia."

#: src/components/loading/Loading.tsx
msgid "While the job is in progress you can:"
msgstr "Mientras el trabajo está en curso, puede:"

#: src/modules/api/resourceTypes.tsx
msgid "With a firewall you can control incoming and outgoing network traffic based on predetermined security rules."
msgstr "Con un cortafuegos puede controlar el tráfico de red entrante y saliente según reglas de seguridad predefinidas."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "With first billing account you will be able to unlock your complimentary free credit of <0><1/></0>."
msgstr "Con su primera cuenta de facturación podrá desbloquear su crédito gratuito de cortesía de <0><1/></0>."

#. placeholder {0}: currency.title
#: src/modules/billing/ConversionMessage.tsx
msgid "With the selected payment method, you will be charged in {0}."
msgstr "Con el método de pago seleccionado, se le cobrará en {0}."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Without an active billing account you can not create any resources, create one to get started."
msgstr "Sin una cuenta de facturación activa no puede crear ningún recurso; cree una para comenzar."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Without an active billing account, resources can not be created."
msgstr "Sin una cuenta de facturación activa, no se pueden crear recursos."

#. Time period unit
#: src/modules/metal/offer/period.tsx
msgid "year"
msgstr ""

#. Server commitment period
#: src/modules/metal/offer/period.tsx
msgid "Yearly"
msgstr ""

#: src/modules/disks/disk/DiskView.tsx
msgid "Yes"
msgstr "Sí"

#: src/modules/user/ActAsModal.tsx
msgid "You are about to access user \"{name}\""
msgstr "Está a punto de acceder como el usuario \"{name}\""

#: src/modules/access/AdminUserWarning.tsx
msgid "You are an administrator and are about to delegate your administrative privileges to another user. Please ensure this action is intentional."
msgstr "Usted es administrador y está a punto de delegar sus privilegios administrativos a otro usuario. Asegúrese de que esta acción sea intencional."

#: src/modules/user/ProfileView.tsx
msgid "You can activate multi-factor authentication for improved security. This works only for the username-password login method. For social login methods (Google etc.), it is usually possible to activate MFA on the third party side."
msgstr "Puede activar la autenticación multifactor para mejorar la seguridad. Esto solo funciona para el método de inicio de sesión con nombre de usuario y contraseña. Para los métodos de inicio de sesión social (Google, etc.), normalmente es posible activar la MFA en el servicio de terceros."

#: src/modules/compute/BootFromIsoModal.tsx
msgid "You can boot your virtual machine from a special image for system recovery or to install a fresh operating system. When this mode is activated, a chosen image will be attached as a boot medium. You can then use the Terminal to access your machine. This boot mode is enabled only for the current launch. Next time this virtual machine is started it will follow the normal boot routine."
msgstr "Puede arrancar su máquina virtual desde una imagen especial para la recuperación del sistema o para instalar un sistema operativo nuevo. Cuando se active este modo, la imagen elegida se adjuntará como medio de arranque. Podrá usar la Consola para acceder a su máquina. Este modo de arranque solo estará habilitado para el inicio actual. La próxima vez que se inicie esta máquina virtual seguirá el procedimiento de arranque normal."

#: src/modules/billing/PaymentReturn.tsx
msgid "You can close this page."
msgstr "Puede cerrar esta página."

#: src/modules/billing/billingAccount/BillingCreate.tsx
msgid "You can create multiple billing accounts, each linked to specific payment methods. This approach allows you to effectively separate and monitor expenses across different teams, departments, or projects."
msgstr "Puede crear varias cuentas de facturación, cada una vinculada a métodos de pago específicos. Este enfoque le permite separar y supervisar los gastos de forma eficaz entre distintos equipos, departamentos o proyectos."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You can do this from here and continue it later by clicking the link in the email we send you."
msgstr "Puede hacerlo desde aquí y continuarlo más tarde haciendo clic en el enlace del correo electrónico que le enviamos."

#: src/modules/billing/referral/ReferralProgram.tsx
msgid "You can earn and give free credits by sharing your unique referral code."
msgstr "Puede ganar y otorgar créditos gratuitos compartiendo su código de referido único."

#: src/modules/metal/commitment/AddCommitmentModal.tsx
msgid "You cannot add another reservation because a future reservation already exists."
msgstr ""

#: src/modules/metal/offer/MetalOfferSection.tsx
msgid "You commit to the full price for the selected period as soon as you confirm the reservation."
msgstr ""

#. placeholder {0}: ipAddress.address
#: src/modules/network/DeleteWithFloatingIp.tsx
msgid "You have a floating IP <0>{0}</0> assigned to this resource."
msgstr "Tiene una dirección IP flotante <0>{0}</0> asignada a este recurso."

#: src/modules/billing/firstAccountNotices.store.tsx
msgid "You have an active campaign code (<0>{referralCode}</0>) pending to get additional bonus!"
msgstr "¡Tiene un código de campaña activo (<0>{referralCode}</0>) para obtener un bono adicional!"

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have billing account validation in progress."
msgstr "Tiene una validación de cuenta de facturación en curso."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "You have completed billing account validation process. Please wait for the final decision."
msgstr "Ha completado el proceso de validación de la cuenta de facturación. Espere la decisión final."

#: src/modules/notifications/NotificationMenu.tsx
msgid "You have no notifications."
msgstr "No tiene notificaciones."

#: src/modules/billing/QrCodeDisplay.tsx
msgid "You may close this dialog after you have made a payment."
msgstr "Puede cerrar este diálogo después de realizar el pago."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "You may close this dialog window for now."
msgstr "Puede cerrar esta ventana de diálogo por ahora."

#: src/modules/storage/bucket/BucketView.tsx
msgid "You need to have at least one access key for browsing files in this bucket."
msgstr ""

#: src/modules/billing/account_validation/GeneralBaValidationBlock.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is approved."
msgstr "Podrá configurar métodos de pago y usar los servicios en la nube una vez que se apruebe la validación."

#: src/modules/billing/NoValidBillingAccountNotice.tsx
msgid "You will be able to set up payment methods and use cloud services once the validation is complete."
msgstr "Podrá configurar métodos de pago y usar los servicios en la nube una vez que finalice la validación."

#: src/modules/metal/MetalLeaseDetailView.tsx
msgid "You will not be charged until it is ready."
msgstr "No se le cobrará hasta que esté listo."

#: src/modules/dashboard/BillingAccounts.tsx
msgid "Your account has been suspended"
msgstr "Su cuenta ha sido suspendida"

#: src/modules/billing/ConversionMessage.tsx
msgid "Your actual charge will be <0/>, with exchange rate of <1/>."
msgstr "Su cargo real será de <0/>, con un tipo de cambio de <1/>."

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account has been suspended. See billing account details for more information and <0>contact support</0> to resolve the issue."
msgstr "Su cuenta de facturación ha sido suspendida. Consulte los detalles de la cuenta de facturación para obtener más información y <0>contacte con soporte</0> para resolver el problema."

#: src/modules/billing/payment/PaymentModal.tsx
msgid "Your billing account has been topped up"
msgstr "Su cuenta de facturación se ha recargado"

#: src/modules/billing/BillingAccountNotices.tsx
msgid "Your billing account must have positive balance to get activated."
msgstr "Su cuenta de facturación debe tener saldo positivo para poder activarse."

#: src/modules/login/Login.tsx
msgid "Your email address has been successfully verified. You can now log in."
msgstr "Su dirección de correo electrónico se ha verificado correctamente. Ya puede iniciar sesión."

#: src/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx
msgid "Your email address has changed since you started validation. Please start over."
msgstr "Su dirección de correo electrónico ha cambiado desde que inició la validación. Por favor, vuelva a empezar."

#: src/modules/billing/BillingDiscountNotice.tsx
msgid "Your selected billing account has {discount}% discount"
msgstr "La cuenta de facturación seleccionada tiene un {discount}% de descuento"

#: src/modules/storage/s3/S3FileBrowser.tsx
msgid "Your storage bucket contains a substantial number of files, and we've temporarily halted the loading process. Simply click the \"Load More\" button to continue loading the next batch of files."
msgstr "Su bucket de almacenamiento contiene una cantidad considerable de archivos y hemos detenido temporalmente la carga de la lista. Simplemente haga clic en el botón \"Cargar más\" para continuar cargando el siguiente lote de archivos."

#: src/modules/billing/billingAccount/fieldsInfo.tsx
msgid "Zip/postal code"
msgstr "Código postal"
